// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:55.668Z
// Property: Mark Apts. (ID: 6767906449165610)
// Collections: 20 amenities, 2 floorplans (live), 24 photos, 63 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165610",
  "property_external_id": "ph2m29v",
  "property_zillow_url": "https://www.zillow.com/homedetails/711-Lake-Harbour-Dr-Ridgeland-MS-39157/68263996_zpid/",
  "property_apartments_url": "https://www.apartments.com/mark-apts-ridgeland-ms/ph2m29v/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Mark+Apartments/data=!4m2!3m1!1s0x0:0xb4c93f9542291ba1?sa=X&ved=2ahUKEwjTouf0-rySAxU1v4kEHWioKx4Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "33359832237",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mark-apts.",
  "property_name": "Mark Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/the-mark/",
  "property_domain": null,
  "property_address": "711 Lake Harbour Drive",
  "property_full_address": "711 Lake Harbour Drive, Ridgeland, MS, 39157",
  "property_address_1": "711 Lake Harbour Dr",
  "property_address_2": null,
  "property_address_city": "Ridgeland",
  "property_address_state": "MS",
  "property_address_zip_full": null,
  "property_address_zip": "39157",
  "property_address_country": "US",
  "property_address_county": "Madison County",
  "property_neighborhood_address": "https://www.caseusa.com/apartments/ms/ridgeland/the-mark/?cpm=apartments",
  "property_address_latitude": "32.4121",
  "property_address_longitude": "-90.1137",
  "property_email": "themark@caseusa.com",
  "property_phone": "(601) 574-5389",
  "property_call_tracking_phone": "855-267-3856",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Mark Apts. in Ridgeland, Mississippi, your ideal home awaits with spacious one and two-bedroom floor plans. Enjoy a refreshing dip in the pool, relax in the clubhouse, or serve up some fun on our tennis court. Experience modern comforts, including air conditioning, walk-in closets, and high-speed internet. Your perfect lifestyle starts here! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Mark Apts. in Ridgeland, Mississippi!**\n\nDiscover your perfect home at Mark Apts., where comfort meets convenience in an inviting community. Nestled in the heart of Ridgeland, our meticulously designed one- and two-bedroom apartments provide the ideal blend of space, style, and modern amenities that cater to your lifestyle. \n\nEmbrace the sunny days by diving into our shimmering pool or enjoying a game of tennis on our courts. For those who appreciate community living, our clubhouse serves as a perfect gathering space, while having a dedicated property manager and maintenance team on-site ensures that your needs are met promptly. \n\nEach apartment boasts essential features, including air conditioning, high-speed internet access, and cable readiness, creating a seamless living experience. Enjoy the convenience of a washer/dryer hookup, a dishwasher, and generous storage space with walk-in closets and a pantry. Many units feature a cozy fireplace, high ceilings, and private balconies or patios, providing the ideal retreat to unwind after a long day.\n\nLiving at Mark Apts. means embracing a smoke-free environment, coupled with easy access to laundry facilities that make chores a breeze. From spacious dining rooms to beautifully designed kitchens equipped with modern appliances, you’ll find everything you need for a comfortable life. \n\nAre you ready to make the move? Explore our floor plans and discover the perfect fit for your needs today. Don’t miss out—**schedule a tour** or browse our availability to find your new home at Mark Apts. in Ridgeland!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-318a-74fa-83ba-fa7eae597807.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with brick and tan siding, balconies, and parking lot.",
    "public_id": "019d20af-318a-74fa-83ba-fa7eae597807",
    "storage_key": "property/6767906449165610/019d20af-318a-74fa-83ba-fa7eae597807.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "256",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.65625",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "We allow up to two pets per apartment (cats and dogs allowed). Pet rent is $30 per pet per month. One-time non‑refundable pet fee is $500 per pet. Breed restrictions apply. No weight limit specified.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://markapartmentsridgeland.securecafe.com/onlineleasing/mark-apts/floorplans.aspx",
  "property_resident_portal_url": "https://markapartmentsridgeland.securecafe.com/residentservices/mark-apts/userlogin.aspx",
  "property_apply_now_url": "https://markapartmentsridgeland.securecafe.com/onlineleasing/mark-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-f49c-74fd-9112-089b8a34efcf.webp",
  "property_primary_logo_media": {
    "alt_text": "The Mark of Ridgeland logo",
    "public_id": "019cfb41-f49c-74fd-9112-089b8a34efcf",
    "storage_key": "property/6767906449165610/019cfb41-f49c-74fd-9112-089b8a34efcf.webp",
    "width": 300,
    "height": 210
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-bf87-73d8-8523-eb0ca94adaf2.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb42-bf87-73d8-8523-eb0ca94adaf2",
    "storage_key": "property/6767906449165610/019cfb42-bf87-73d8-8523-eb0ca94adaf2.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-ca3b-77d9-9d3b-373fd6c3e5db.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Mark of Ridgeland logo",
    "public_id": "019cfb42-ca3b-77d9-9d3b-373fd6c3e5db",
    "storage_key": "property/6767906449165610/019cfb42-ca3b-77d9-9d3b-373fd6c3e5db.webp",
    "width": 300,
    "height": 210
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-d1da-70ae-bd75-c14e4b6495f1.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Mark of Ridgeland logo",
    "public_id": "019cfb42-d1da-70ae-bd75-c14e4b6495f1",
    "storage_key": "property/6767906449165610/019cfb42-d1da-70ae-bd75-c14e4b6495f1.webp",
    "width": 300,
    "height": 210
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#a34123",
  "property_secondary_color": "#3d3d3f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1100 - 1100",
  "property_sqft_min": "1100",
  "property_sqft_max": "1100",
  "property_price_range": "1364 - 1374",
  "property_price_min": "1364",
  "property_price_max": "1374",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/TheMarkApartments/photos/d41d8cd9/399580235504915/",
  "property_instagram_url": "https://www.instagram.com/themarkridgeland/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJIS7sck3SKYYRoRspQpU_ybQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-mark-apartments-ridgeland-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Mark Apts.",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "At Mark Apts. in Ridgeland, Mississippi, unwind in stylish one and two-bedroom homes designed for modern living. Enjoy exceptional amenities like a refreshing pool, cozy clubhouse, and on-site maintenance. With spacious layouts, walk-in closets, and high-speed internet, your perfect sanctuary awaits. Experience elevated living today!",
  "property_home_floorplans_blurb": "Welcome to Mark Apts., where modern living meets comfort in Ridgeland, Mississippi. Choose from stylish one and two-bedroom floor plans designed to suit your lifestyle. Browse our available apartments today and uncover the ideal home tailored just for you in a community that truly feels like home.",
  "property_home_gallery_blurb": "At Mark Apts. in Ridgeland, Mississippi, luxury meets comfort. Choose from spacious one or two-bedroom floor plans, complete with modern amenities like a refreshing pool, clubhouse, and tennis court. Elevate your lifestyle with walk-in closets, high-speed internet, and scenic balconies. Picture yourself living here—your oasis awaits!",
  "property_home_neighborhood_blurb": "Welcome to Mark Apts. in Ridgeland, where convenience meets comfort! Nestled near parks, cutting-edge fitness centers, and local colleges, our community thrives amidst vibrant attractions. Enjoy quick access to LeFleur's Bluff State Park, Urban Air Trampoline Park, and dynamic shopping at Northpark. Experience the best of Mississippi living today!",
  "property_home_reviews_blurb": "At Mark Apts in Ridgeland, Mississippi, residents praise our spacious layouts and exceptional service. One happy tenant shares, \"Since I moved here, the customer service has been awesome. The staff knows me by name.\" Discover all that our community offers and see what makes us stand out!",
  "property_neighborhood_blurb": "Nestled in the heart of Ridgeland, Mark Apts. offers more than just a place to live—it's a gateway to adventure. Nearby, unwind at LeFleur's Bluff State Park or energize at Planet Fitness. With convenient access to shopping and recreation, your perfect lifestyle awaits just beyond your doorstep. Explore the vibrant neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Mark Apts. in Ridgeland, Mississippi, indulge in a lifestyle filled with luxury and convenience. Enjoy refreshing dips in the pool, unwind in the clubhouse, or challenge friends on the tennis court. Experience spacious one and two-bedroom homes featuring walk-in closets, high ceilings, and your own private balcony—comfort awaits!",
  "property_applynow_blurb": "At Mark Apts. in Ridgeland, Mississippi, your perfect living space awaits! Choose from stylish one and two-bedroom floor plans, and enjoy superb amenities like a refreshing pool, inviting clubhouse, and on-site maintenance. With walk-in closets and a cozy fireplace, make every day feel like home. Lease online today!",
  "property_contactus_blurb": "At Mark Apts. in Ridgeland, Mississippi, our thoughtfully designed one and two-bedroom floor plans create an inviting retreat for every lifestyle. Whether you're lounging in your spacious living area or enjoying views from your balcony, comfort awaits. Have questions? Contact our leasing team today to learn more!",
  "property_faqs_blurb": "At Mark Apts. in Ridgeland, Mississippi, each thoughtfully designed one and two-bedroom floor plan offers a welcoming retreat. Have questions about our community? Our FAQs page has you covered with all the insights you need to make Mark Apts. your new home. Dive in and get informed today!",
  "property_floorplans_blurb": "At Mark Apts. in Ridgeland, Mississippi, thoughtfully designed one and two-bedroom floor plans await you. Each space reflects comfort and style, creating a haven you'll love coming home to. Browse our available apartment homes today and uncover the ideal layout that suits your lifestyle perfectly. Your perfect retreat is just a click away!",
  "property_gallery_blurb": "At Mark Apartments in Ridgeland, Mississippi, envision your ideal lifestyle. Choose from spacious one and two-bedroom floor plans featuring high ceilings and walk-in closets. Dive into refreshment at our inviting pool, unwind in the clubhouse, or enjoy outdoor spaces with tennis courts and balconies. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Mark Apts. in Ridgeland, Mississippi—your serene sanctuary featuring spacious one- and two-bedroom floor plans. Enjoy on-site amenities like a refreshing pool, tennis court, and clubhouse, all complemented by modern comforts such as high-speed internet and walk-in closets. Uncover your ideal home using our interactive community map!",
  "property_pets_blurb": "At Mark Apts. in scenic Ridgeland, MS, your furry friends are family! Bring up to two pets, and enjoy a vibrant community where tails wag and hearts grow. With convenient pet policies, your home will be a haven for both you and your beloved companions. Join us today!",
  "property_referafriend_blurb": "At Mark Apts. in Ridgeland, Mississippi, we believe great friends make great neighbors! Share the joy of spacious one and two-bedroom floor plans in a vibrant community. Refer a friend today and create lasting memories surrounded by comfort and camaraderie. Your next adventure awaits right at your doorstep!",
  "property_residentaccess_blurb": "At Mark Apts. in Ridgeland, Mississippi, your new home awaits! Choose from thoughtfully designed one and two-bedroom floor plans tailored to fit your lifestyle. Ready to simplify life? Access your resident portal now to effortlessly pay rent, schedule maintenance, and stay connected with your community!",
  "property_reviews_blurb": "At Mark Apts. in Ridgeland, Mississippi, residents rave about our spacious floor plans and exceptional service. One happy tenant notes, “The staff is friendly and know me by name,” highlighting our commitment to making your living experience truly enjoyable. See what our residents have to say about living at our community!",
  "property_created_at": "1753982386151",
  "property_scheduletour_blurb": "At Mark Apts. in Ridgeland, Mississippi, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Experience comfort and convenience in a welcoming community. Ready to see why residents love calling Mark Apts. home? Schedule a tour today and hear their stories firsthand!",
  "property_thankyou_blurb": "Thank you for sharing your information with us! At Mark Apts. in Ridgeland, Mississippi, our thoughtfully designed floor plans include inviting one and two-bedroom options tailored for your lifestyle. Our dedicated team will reach out soon to help you find your perfect home. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "At Mark Apts. in Ridgeland, Mississippi, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Experience the charm of our community from the comfort of your home—take a virtual tour today and envision your next chapter with us!",
  "property_copyright": "2025 All Rights Reserved. Mark Apts.",
  "property_seo_title_home": "Mark Apts. |  Apartments in Ridgeland, Mississippi",
  "property_seo_description_home": "Elevate your living at Mark Apts. in Ridgeland, MS. Enjoy spacious layouts, premium amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Ridgeland, Mississippi Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Mark Apts. in Ridgeland, MS! From cozy one-bedrooms to spacious two-bedrooms, our floor plans fit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Ridgeland, Mississippi Apartments for Rent",
  "property_seo_description_amenities": "Discover the charm of Mark Apts. in Ridgeland! Enjoy our pool, cozy clubhouse, and spacious, modern apartments. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Ridgeland, Mississippi",
  "property_seo_description_gallery": "Capture the essence of luxury living at Mark Apts. in Ridgeland! Picture your dream home complete with a pool, tennis court, and spacious layouts.",
  "property_seo_title_virtualtours": "Virtual Tours | Mark Apts. Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Mark Apts. in Ridgeland, MS! Take a virtual tour of our stunning one and two-bedroom apartments designed for your lifestyle.",
  "property_seo_title_interactivemap": "Interactive Map | Mark Apts. Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Mark Apts. in Ridgeland, MS! Check out our interactive map for available one and two-bedroom apartments featuring top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Ridgeland, Mississippi",
  "property_seo_description_neighborhood": "Uncover the charm of Ridgeland! Mark Apts. offers vibrant neighborhoods filled with local favorites and attractions. Dive into your new community today.",
  "property_seo_title_contact": "Contact Us | Mark Apts.",
  "property_seo_description_contact": "Connect with Mark Apts. in Ridgeland, MS! Inquire about our one- and two-bedroom floor plans. Your ideal home awaits—reach out to our team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Ridgeland, Mississippi",
  "property_seo_description_faqs": "Find answers to your questions about Mark Apts. in Ridgeland, MS! Learn about our floor plans, amenities, and life at our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Ridgeland, Mississippi",
  "property_seo_description_reviews": "See why residents love calling Mark Apts. in Ridgeland home! From spacious floor plans to top-notch amenities, their stories showcase a vibrant community life.",
  "property_seo_title_applynow": "Apply Now | Apartments in Ridgeland, Mississippi",
  "property_seo_description_applynow": "Find your ideal home at Mark Apts. in Ridgeland! Enjoy spacious one- and two-bedroom layouts with amazing amenities, plus easy online leasing. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Mark Apts.",
  "property_seo_description_residentaccess": "Manage your Mark Apts. living experience effortlessly! Log in to access rent payments, maintenance requests, and exclusive resident perks in Ridgeland, MS!",
  "property_seo_title_referafriend": "Refer A Friend | Mark Apts.",
  "property_seo_description_referafriend": "Refer a friend to Mark Apts in Ridgeland, MS! Great friends make the best neighbors. Join our vibrant community together and elevate your living experience!",
  "property_seo_title_scheduletour": "Schedule a Tour | Mark Apts.",
  "property_seo_description_scheduletour": "Experience modern living at Mark Apts. in Ridgeland, MS. Schedule your tour today and reveal your future home in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Mark Apts.",
  "property_seo_description_privacy": "At Mark Apts. in Ridgeland, MS, your privacy matters. Delve into our commitment to your security and comfort—read our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Mark Apts.",
  "property_seo_description_accessibility": "At Mark Apts. in Ridgeland, we embrace digital inclusion, ensuring accessibility for all residents. Join our community where everyone feels at home!",
  "property_seo_title_sitemap": "Sitemap | Mark Apts.",
  "property_seo_description_sitemap": "Unravel the charm of Mark Apts. in Ridgeland! Navigate our sitemap for a glimpse of stylish living, amenities, and your next home sweet home.",
  "property_seo_title_thankyou": "Thank You | Mark Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Mark Apts in Ridgeland, MS! Our team will connect soon to help you find your perfect home. Your journey starts here!",
  "property_seo_title_pets": "Pet Policy | Apartments in Ridgeland, MS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865375031",
  "amenities": [
    {
      "id": "custom_20b2fb68-23c5-4623-a8b6-5ce2772ef493",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be5fa797-da38-44de-b079-d5e6e0eae7b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab9682df-b26c-4a04-b6f4-c3e45c683d0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2841ab2b-6f3c-4017-a0d7-a3fab39f5d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Swimming Pool with Cabana",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_196ad172-e53f-4d0a-8249-332fe390607a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13588e89-87ff-477e-b934-895afe1951e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Tennis Courts",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ef8add87-b4f7-4158-a2a4-8126a632d631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b817ea6-1afe-4bca-b850-77790fa0afe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26938755-b032-43be-b387-2069c96fb520",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Ample Open Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e610c99-1325-42a1-9ea4-6045321242dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Caring Management On‑site",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ca2c262-b33e-4cee-9118-f09cc39bae62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Get Connected To Super‑Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8cac9139-030e-4d3c-90ac-060822d24e71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ac42ca2-4bc3-4677-8106-8fc85d85d975",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6e12ac0-ce0e-4fb0-a7b5-0af368134876",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Energy‑Efficient Appliances in oversized Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dcf247f7-8234-4b79-8827-d87ed1811a8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplaces",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_771ddc90-8838-4b25-960a-df1183410f4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be6fcf4d-cf9d-408c-990a-f8a07b5899a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Large Private Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e3ceed3-7ee4-4d74-867d-22de04dfd713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7859480-70e2-408b-bd05-69aa2a618315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe9c9f16-b9e3-444f-906a-0dee63add4a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Living Areas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_43ca4e92-f056-46e8-a7c3-9bd19b7b42c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-3163-7734-a831-7c376edcdd1c.webp",
      "image_media": {
        "alt_text": "Aerial view of a multi-building apartment complex with parking lots and trees.",
        "public_id": "019d20af-3163-7734-a831-7c376edcdd1c",
        "storage_key": "property/6767906449165610/019d20af-3163-7734-a831-7c376edcdd1c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Aerial exterior of the apartment community showing brick buildings, parked cars, and green spaces.",
      "link": "",
      "alt_text": "Aerial view of a multi-building apartment complex with parking lots and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-a9a1-70f7-8c78-106ab5e8912e.webp"
    },
    {
      "id": "custom_6f153b4b-4d1f-4b77-9865-15d89d8da2d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-3178-757c-994b-5e44c72e6ea3.webp",
      "image_media": {
        "alt_text": "Exterior view of a leasing office at a multifamily property with handicap parking and landscaping.",
        "public_id": "019d20af-3178-757c-994b-5e44c72e6ea3",
        "storage_key": "property/6767906449165610/019d20af-3178-757c-994b-5e44c72e6ea3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of the leasing office at a multifamily property, featuring brick and siding facade, landscaping, and a designated handicap parking space.",
      "link": "",
      "alt_text": "Exterior view of a leasing office at a multifamily property with handicap parking and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-ad35-7426-b126-52856d183a6c.webp"
    },
    {
      "id": "custom_4ee610d1-55bf-4e2e-92b4-345a7c8a0e61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-318a-74fa-83ba-fa7eae597807.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with balconies and a parking lot.",
        "public_id": "019d20af-318a-74fa-83ba-fa7eae597807",
        "storage_key": "property/6767906449165610/019d20af-318a-74fa-83ba-fa7eae597807.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment community showing balconies, stair entrances, and landscaped grounds.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-c13b-7137-a44c-167f58bf2558.webp"
    },
    {
      "id": "custom_5cc15210-2bd0-4747-b6dd-7616e95ceab8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-3222-7784-a798-826df0840cc9.webp",
      "image_media": {
        "alt_text": "Outdoor tennis court with white lines and brick apartment buildings in the background.",
        "public_id": "019d20af-3222-7784-a798-826df0840cc9",
        "storage_key": "property/6767906449165610/019d20af-3222-7784-a798-826df0840cc9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor tennis courts and landscaped grounds at a multi-family community.",
      "link": "",
      "alt_text": "Outdoor tennis court with white lines and brick apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-a833-75ea-93ef-1f15f9cd2255.webp"
    },
    {
      "id": "custom_86532730-0bba-4ed3-bc6c-a1760fbc919f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-3b58-74da-bfed-dc19a4a7fbc9.webp",
      "image_media": {
        "alt_text": "Outdoor tennis court with a net, adjacent to brick apartment buildings and manicured landscaping.",
        "public_id": "019d20af-3b58-74da-bfed-dc19a4a7fbc9",
        "storage_key": "property/6767906449165610/019d20af-3b58-74da-bfed-dc19a4a7fbc9.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Outdoor community tennis court at a multifamily property, with brick buildings and green landscaping in the background.",
      "link": "",
      "alt_text": "Outdoor tennis court with a net, adjacent to brick apartment buildings and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb41-fd0d-7562-b045-ee3d4a8167de.webp"
    },
    {
      "id": "custom_54cea720-908d-4366-bf35-a8ce3da2100e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-3cce-721e-bc07-be9bda1fa355.webp",
      "image_media": {
        "alt_text": "Entrance sign for The Mark of Ridgeland apartment community with landscaping and a car nearby",
        "public_id": "019d20af-3cce-721e-bc07-be9bda1fa355",
        "storage_key": "property/6767906449165610/019d20af-3cce-721e-bc07-be9bda1fa355.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior shot of a multifamily community entrance featuring a large sign, landscaped bed, and surrounding trees.",
      "link": "",
      "alt_text": "Entrance sign for The Mark of Ridgeland apartment community with landscaping and a car nearby",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-ad2b-7650-bf6d-619474fd8c56.webp"
    },
    {
      "id": "custom_a57bb8ac-e0df-483e-8cca-0a0f8be26259",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-3cd4-7429-9ef9-5fc3a8c68530.webp",
      "image_media": {
        "alt_text": "Outdoor community pool area with lounge chairs, a shaded gazebo, and surrounding trees.",
        "public_id": "019d20af-3cd4-7429-9ef9-5fc3a8c68530",
        "storage_key": "property/6767906449165610/019d20af-3cd4-7429-9ef9-5fc3a8c68530.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Poolside lounge area at a multifamily community, featuring a shaded pavilion and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor community pool area with lounge chairs, a shaded gazebo, and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb41-f4af-758d-a049-f4d016cde6ba.webp"
    },
    {
      "id": "custom_5c0f7b8a-7f4c-4d80-9a1f-41eeeafd4795",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-401d-756c-a8a0-b175a0e8d444.webp",
      "image_media": {
        "alt_text": "Open communal kitchen and dining area with a wood vaulted ceiling and large windows.",
        "public_id": "019d20af-401d-756c-a8a0-b175a0e8d444",
        "storage_key": "property/6767906449165610/019d20af-401d-756c-a8a0-b175a0e8d444.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious community kitchen with island, modern appliances, and a dining area for residents, bathed in natural light.",
      "link": "",
      "alt_text": "Open communal kitchen and dining area with a wood vaulted ceiling and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-a965-71da-8caf-512504e31cfb.webp"
    },
    {
      "id": "custom_df61c688-2907-42e0-bfa4-8bd2bd66ded7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-491b-7049-9b9d-f5a493ddd8c7.webp",
      "image_media": {
        "alt_text": "Open-concept community lounge with sofa, chairs, kitchen island, and dining table under wood-beamed ceiling.",
        "public_id": "019d20af-491b-7049-9b9d-f5a493ddd8c7",
        "storage_key": "property/6767906449165610/019d20af-491b-7049-9b9d-f5a493ddd8c7.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Bright resident lounge with a full kitchen, dining area, and plentiful seating for gatherings.",
      "link": "",
      "alt_text": "Open-concept community lounge with sofa, chairs, kitchen island, and dining table under wood-beamed ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb41-fd2f-705d-af43-9dc37a675233.webp"
    },
    {
      "id": "custom_391da534-39b1-4762-999c-7941e64b47a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-4aa9-7261-812e-daf9f90245ad.webp",
      "image_media": {
        "alt_text": "Spacious communal living area with a gray sectional sofa, orange leather chairs, and a central kitchen island.",
        "public_id": "019d20af-4aa9-7261-812e-daf9f90245ad",
        "storage_key": "property/6767906449165610/019d20af-4aa9-7261-812e-daf9f90245ad.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious community lounge with seating and a kitchen island for residents.",
      "link": "",
      "alt_text": "Spacious communal living area with a gray sectional sofa, orange leather chairs, and a central kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-c13a-74b8-9fb7-734aef11198f.webp"
    },
    {
      "id": "custom_5910133b-f6e2-4d5a-83f9-08daf31abb41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-4afa-77cc-b7ca-80c95df152a0.webp",
      "image_media": {
        "alt_text": "L-shaped kitchen with oak cabinets, white countertops, black refrigerator, and a double sink.",
        "public_id": "019d20af-4afa-77cc-b7ca-80c95df152a0",
        "storage_key": "property/6767906449165610/019d20af-4afa-77cc-b7ca-80c95df152a0.webp",
        "width": 1734,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with oak cabinets, white countertops, and stainless-steel appliances.",
      "link": "",
      "alt_text": "L-shaped kitchen with oak cabinets, white countertops, black refrigerator, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb41-fe27-743e-bc74-1a9647f5e712.webp"
    },
    {
      "id": "custom_ec1e976c-464b-4022-a31b-ac99184e618b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-4e7e-7053-93e7-6be065a0ac8e.webp",
      "image_media": {
        "alt_text": "Community laundry room with multiple white washing machines and dryers.",
        "public_id": "019d20af-4e7e-7053-93e7-6be065a0ac8e",
        "storage_key": "property/6767906449165610/019d20af-4e7e-7053-93e7-6be065a0ac8e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "On-site laundry facility for residents featuring multiple white washers and dryers in a clean, well-lit room.",
      "link": "",
      "alt_text": "Community laundry room with multiple white washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-be39-75df-907e-4d296f0d2077.webp"
    },
    {
      "id": "custom_0a5b4a5d-9c13-422f-85cf-49dd8f4d6abd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-564c-75ab-9030-9ca6575a8c69.webp",
      "image_media": {
        "alt_text": "Dining area with a round wall mirror, a wooden dining table, and matching chairs.",
        "public_id": "019d20af-564c-75ab-9030-9ca6575a8c69",
        "storage_key": "property/6767906449165610/019d20af-564c-75ab-9030-9ca6575a8c69.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy dining nook inside an apartment featuring a round mirror, stylish wooden chairs, and built-in storage.",
      "link": "",
      "alt_text": "Dining area with a round wall mirror, a wooden dining table, and matching chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb42-0781-777f-8104-4072a3618865.webp"
    },
    {
      "id": "custom_80cc1fc0-7b46-40ff-a5a4-49f2db6a4e2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-5862-76ec-8c06-d6104f56e6ca.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a brick fireplace, white sofa, pink chairs, and a sliding balcony door.",
        "public_id": "019d20af-5862-76ec-8c06-d6104f56e6ca",
        "storage_key": "property/6767906449165610/019d20af-5862-76ec-8c06-d6104f56e6ca.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment living room with a brick fireplace, white sofa, pink accent chairs, glass coffee table, and a sliding balcony door.",
      "link": "",
      "alt_text": "Living room in an apartment with a brick fireplace, white sofa, pink chairs, and a sliding balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-a98a-757e-9eda-09abe7381a87.webp"
    },
    {
      "id": "custom_627158d3-3374-4a1d-9473-c22b40712d7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-5cec-737a-bb1a-450838dfe371.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with wooden cabinets, black stove and fridge, and a double sink.",
        "public_id": "019d20af-5cec-737a-bb1a-450838dfe371",
        "storage_key": "property/6767906449165610/019d20af-5cec-737a-bb1a-450838dfe371.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with warm wood cabinets, black appliances, and a compact layout.",
      "link": "",
      "alt_text": "Kitchen in an apartment with wooden cabinets, black stove and fridge, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-ad2b-7650-bf6d-679f55de2185.webp"
    },
    {
      "id": "custom_e0adb2d6-45b9-48f4-a7c1-95b795a38a18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-5bf9-75ca-a08e-ea6eddc5b55e.webp",
      "image_media": {
        "alt_text": "Bathroom with tub/shower, toilet, granite countertop vanity, and blue patterned shower curtain.",
        "public_id": "019d20af-5bf9-75ca-a08e-ea6eddc5b55e",
        "storage_key": "property/6767906449165610/019d20af-5bf9-75ca-a08e-ea6eddc5b55e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a tub/shower, granite countertop vanity, and colorful wall art.",
      "link": "",
      "alt_text": "Bathroom with tub/shower, toilet, granite countertop vanity, and blue patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-a5f2-708d-9f56-c4700038b8e1.webp"
    },
    {
      "id": "custom_5b1f6cb6-ee09-4ad4-9678-db8090dffcc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-63d6-74ff-b121-95fd464b2fb2.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a white upholstered bed, nightstand, lamp, ceiling fan, and abstract wall art.",
        "public_id": "019d20af-63d6-74ff-b121-95fd464b2fb2",
        "storage_key": "property/6767906449165610/019d20af-63d6-74ff-b121-95fd464b2fb2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a modern apartment featuring a white upholstered bed, pink comforter, blue throw, decorative pillows, and abstract wall art.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a white upholstered bed, nightstand, lamp, ceiling fan, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-bb2f-75eb-992e-a7cadea95218.webp"
    },
    {
      "id": "custom_ff3bfbed-03b2-4e79-923f-f6584c041a4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-673b-73cd-9412-10b3e9bb221e.webp",
      "image_media": {
        "alt_text": "Bedroom with a light wood bed frame, white dresser, and neutral decor.",
        "public_id": "019d20af-673b-73cd-9412-10b3e9bb221e",
        "storage_key": "property/6767906449165610/019d20af-673b-73cd-9412-10b3e9bb221e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom featuring a light wood bed, white dresser, and soft neutral accents.",
      "link": "",
      "alt_text": "Bedroom with a light wood bed frame, white dresser, and neutral decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-be49-771b-8165-45114d7fb800.webp"
    },
    {
      "id": "custom_6301e0e1-3050-4f64-b49a-ec4ef687b106",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-67eb-7705-a1e4-fe87f2e54d97.webp",
      "image_media": {
        "alt_text": "Interior dining area with a round wooden table and upholstered chairs, large circular wall mirror.",
        "public_id": "019d20af-67eb-7705-a1e4-fe87f2e54d97",
        "storage_key": "property/6767906449165610/019d20af-67eb-7705-a1e4-fe87f2e54d97.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment dining area with round wood table, mid-century chairs, and a large circular mirror.",
      "link": "",
      "alt_text": "Interior dining area with a round wooden table and upholstered chairs, large circular wall mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-c100-716d-80e3-1650f00c6fb8.webp"
    },
    {
      "id": "custom_7b2b34e0-06f5-4c80-bbc3-fac2b5cb4f94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-67fc-76ce-a3d4-650fdc2a91ba.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment unit with sink, vanity, toilet, and blue striped shower curtain.",
        "public_id": "019d20af-67fc-76ce-a3d4-650fdc2a91ba",
        "storage_key": "property/6767906449165610/019d20af-67fc-76ce-a3d4-650fdc2a91ba.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior shot of an apartment bathroom with a granite countertop vanity, toilet, and a tub/shower.",
      "link": "",
      "alt_text": "Bathroom in an apartment unit with sink, vanity, toilet, and blue striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-c495-72f5-bcdf-153112f03a8b.webp"
    },
    {
      "id": "custom_e0ab6450-fd06-4bb6-aa9e-1ae435ce001a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-6e50-77a9-b182-8c8cdee65c58.webp",
      "image_media": {
        "alt_text": "Silhouette of a city skyline at sunset.",
        "public_id": "019d20af-6e50-77a9-b182-8c8cdee65c58",
        "storage_key": "property/6767906449165610/019d20af-6e50-77a9-b182-8c8cdee65c58.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Lifestyle",
      "description": "Silhouette photo of a city skyline at sunset, ideal as a backdrop for a multifamily property's gallery.",
      "link": "",
      "alt_text": "Silhouette of a city skyline at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb41-ff85-702b-9dee-87a8f5645e8a.webp"
    },
    {
      "id": "custom_94fe9ebf-7138-4806-a2f1-24d834b71117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-73e6-7201-91e9-9e99581dc4d1.webp",
      "image_media": {
        "alt_text": "Aerial cityscape with a central church and grid of streets.",
        "public_id": "019d20af-73e6-7201-91e9-9e99581dc4d1",
        "storage_key": "property/6767906449165610/019d20af-73e6-7201-91e9-9e99581dc4d1.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Lifestyle",
      "description": "Aerial view of an urban neighborhood with a central church and surrounding buildings.",
      "link": "",
      "alt_text": "Aerial cityscape with a central church and grid of streets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb42-025a-7443-bb7c-1752043190cd.webp"
    },
    {
      "id": "custom_b180db4c-15b3-4167-abfd-27162b9a8c7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-73e7-76de-89c0-77ddf48051bd.webp",
      "image_media": {
        "alt_text": "Evening view of a rock pedestal with a tall orange statue beside a water feature in a landscaped park.",
        "public_id": "019d20af-73e7-76de-89c0-77ddf48051bd",
        "storage_key": "property/6767906449165610/019d20af-73e7-76de-89c0-77ddf48051bd.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Exterior view of a landscaped park with a rock pedestal statue beside a tranquil canal, representing the community grounds.",
      "link": "",
      "alt_text": "Evening view of a rock pedestal with a tall orange statue beside a water feature in a landscaped park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165610/019cfb42-0378-71cf-81f3-df4e3cc6d8f9.webp"
    },
    {
      "id": "custom_2d82ab0c-500c-4c92-b820-2f7f3159097c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019db140-87fb-76f9-836c-242983bfa074.webp",
      "image_media": {
        "alt_text": "The Mark of Ridgeland monument sign and apartment building exterior.",
        "public_id": "019db140-87fb-76f9-836c-242983bfa074",
        "storage_key": "property/6767906449165610/019db140-87fb-76f9-836c-242983bfa074.webp",
        "width": 3072,
        "height": 2489
      },
      "title": "Community",
      "description": "Welcome to The Mark of Ridgeland, featuring beautiful apartment buildings and lush landscaping. Enjoy our community amenities and find your perfect home.",
      "link": "",
      "alt_text": "The Mark of Ridgeland monument sign and apartment building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fabc6404-12bc-4279-b66c-dba00c7f8b6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Mama Hamil's Southern Cookin' and Bar B Que Buffet",
      "poi_type": "Restaurants",
      "poi_address": "480 Magnolia St, Madison, MS 39110, USA",
      "poi_short_description": "Spacious buffet chain featuring Southern-style comfort food such as fried chicken and desserts along with a salad bar.",
      "poi_long_description": "People say this barbecue restaurant serves delicious Southern dishes, including fried chicken, ribs, and catfish, as well as a wide variety of vegetables and desserts like peach cobbler and bread pudding. They highlight the generous portions, reasonable prices, and the home-cooked, soul food experience. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-2705-76e9-b869-31ec60b08bd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2705-76e9-b869-31ec60b08bd8",
        "storage_key": "property/6767906449165610/019d2709-2705-76e9-b869-31ec60b08bd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hamils.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010288085330032935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mama-hamils-southern-cookin-and-bar-b-que-buffet",
      "poi_latitude": "32.444675",
      "poi_longitude": "-90.122784",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-856-4407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5649-776b-95cd-2c4e0ab14d34",
        "storage_key": "property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3jiACfSKYYRJ_nPuK1mzJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_94257215-3754-46a6-8cfc-b20303f76fe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Shaggy's on the Rez",
      "poi_type": "Restaurants",
      "poi_address": "1733 Spillway Rd, Brandon, MS 39047, USA",
      "poi_short_description": "Popular, lively restaurant and bar serving seafood-inspired fare and featuring outdoor seating with reservoir views.",
      "poi_long_description": "People say this restaurant serves delicious oysters, shrimp, and mahi mahi tacos. They highlight the generous portions, fun atmosphere with live music, and beautiful views of the reservoir. They also like the attentive and friendly service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-270c-7548-9a10-c86a10187c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-270c-7548-9a10-c86a10187c78",
        "storage_key": "property/6767906449165610/019d2709-270c-7548-9a10-c86a10187c78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shaggys.com/locations/on-the-rez/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606896511369096172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shaggys-on-the-rez",
      "poi_latitude": "32.3882456",
      "poi_longitude": "-90.04912420000001",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-724-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5649-776b-95cd-2c4e0ab14d34",
        "storage_key": "property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJycGXC-nVKYYR7CtEOJWx9K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6ea6ae79-4f6a-48ed-8c4f-49628c9b3e7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "988 Top St, Flowood, MS 39232, USA",
      "poi_short_description": "Family-friendly buffet with an array of American fare, from breakfast to dinner.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including steak, potatoes, fried chicken, and a salad bar. They also highlight the friendly and attentive staff, and the clean atmosphere.\n\nSome reviews mention the food can be lukewarm.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-276a-7288-9ea4-554177e7b66f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-276a-7288-9ea4-554177e7b66f",
        "storage_key": "property/6767906449165610/019d2709-276a-7288-9ea4-554177e7b66f.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.goldencorral.com/locations/682/golden-corral-top-street?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=682",
      "poi_directions_map_url": "https://maps.google.com/?cid=5732979269932144382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "32.327924",
      "poi_longitude": "-90.121621",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-420-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5649-776b-95cd-2c4e0ab14d34",
        "storage_key": "property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdgWVRctKIYR_tb7eEWij08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_da93d330-52f2-45ac-9e30-0bc7780140ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "202 E Layfair Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Counter-serve chicken finger specialist popular for its signature Cane's sauce. Fries and Texas toast come with many of the fried chicken combos.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and fries. They highlight the food is hot and fresh, and the drive-thru is quick. They also like the friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-26d2-74af-bc0c-9796b4ef5f97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-26d2-74af-bc0c-9796b4ef5f97",
        "storage_key": "property/6767906449165610/019d2709-26d2-74af-bc0c-9796b4ef5f97.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ms/flowood/202-e.-layfair-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=119709276499798027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.3313599",
      "poi_longitude": "-90.1053988",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-933-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5649-776b-95cd-2c4e0ab14d34",
        "storage_key": "property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHz4FBecsKIYRC-gW5vNKqQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9cddea63-63b6-4ad3-966f-d644bf676f6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1873 Main St, Madison, MS 39110, USA",
      "poi_short_description": "Fast-food chain popular for chicken sandwiches and nuggets, along with kids' meals and catering.",
      "poi_long_description": "People say this fast food restaurant offers delicious food and fries. They highlight the convenient locations, children's play space, and fast drive-through. They also like the friendly staff and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-2c75-7241-9b5c-a1d63bc55cd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2c75-7241-9b5c-a1d63bc55cd8",
        "storage_key": "property/6767906449165610/019d2709-2c75-7241-9b5c-a1d63bc55cd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ms/madison-ms?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=417678638787326989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.46803",
      "poi_longitude": "-90.1307161",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-898-2338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5649-776b-95cd-2c4e0ab14d34",
        "storage_key": "property/6767906449165610/019d2709-5649-776b-95cd-2c4e0ab14d34.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6QgS5XRKYYRDfQvT4LkywU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_4c513ee6-33ad-4a10-8186-305fa569e1db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Northpark",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Climate-controlled mall with 120+ shops, a food court, an arcade, and a play area.",
      "poi_long_description": "People say this shopping center offers a variety of shops and dining options, including American Deli and Belk. They also highlight the friendly staff and safe environment.\n\nOther reviews mention there can be leaks from the ceiling.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-2b89-75f8-9629-5f460b2c001d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2b89-75f8-9629-5f460b2c001d",
        "storage_key": "property/6767906449165610/019d2709-2b89-75f8-9629-5f460b2c001d.webp",
        "width": 1280,
        "height": 819
      },
      "poi_business_url": "http://www.visitnorthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14074278564042696477&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northpark",
      "poi_latitude": "32.4030556",
      "poi_longitude": "-90.1291667",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-863-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-56e9-7548-827f-1ef8770dc084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-56e9-7548-827f-1ef8770dc084",
        "storage_key": "property/6767906449165610/019d2709-56e9-7548-827f-1ef8770dc084.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhY9vW4rSKYYRHeeoB8nhUcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f790bace-4b79-4258-839d-c7e5165a4293",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4500 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Upscale store selling organic foods (including grass-fed meats) as well as baked goods, flowers, seafood and salads along with prepared items.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, specialty items, and a hot bar with a variety of options. They highlight the reasonable prices for the buffet and the clean, well-organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-2c54-775c-af95-f06cd8cd104b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2c54-775c-af95-f06cd8cd104b",
        "storage_key": "property/6767906449165610/019d2709-2c54-775c-af95-f06cd8cd104b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/jkn?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173301360047794626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.3543087",
      "poi_longitude": "-90.1502174",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-608-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5767-7767-9b73-d64f772554dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5767-7767-9b73-d64f772554dc",
        "storage_key": "property/6767906449165610/019d2709-5767-7767-9b73-d64f772554dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8w7oKoyKIYRwqnRtMr30LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5692705d-4a6c-4179-a7e1-b444f0d41a9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4910 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers a wide variety of products. They also highlight the staff can be helpful and friendly.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-2c14-75cc-8a3b-c8f7c43bd33f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2c14-75cc-8a3b-c8f7c43bd33f",
        "storage_key": "property/6767906449165610/019d2709-2c14-75cc-8a3b-c8f7c43bd33f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ms/jackson/jacksonian-plaza/025/00345?cid=loc_02500345_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562485936542992699&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.3637911",
      "poi_longitude": "-90.1479131",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-366-1141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5767-7767-9b73-d64f772554dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5767-7767-9b73-d64f772554dc",
        "storage_key": "property/6767906449165610/019d2709-5767-7767-9b73-d64f772554dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_-AxKsyKIYRO0l8f2bqVq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_86bb32fa-47e1-45bc-9ce3-70aab9e3897b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "120 Ridge Way, Flowood, MS 39232, USA",
      "poi_short_description": "Hardware and appliance retailer, offering installation and repair services plus flooring, paint, rugs, and plants.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-2fe6-7595-9ee1-d94270f9ebeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2fe6-7595-9ee1-d94270f9ebeb",
        "storage_key": "property/6767906449165610/019d2709-2fe6-7595-9ee1-d94270f9ebeb.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MS-Flowood/2553?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2553-_-na-_-0-_-0&y_source=1_MTE4MzYzNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9943658338956026944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.3408446",
      "poi_longitude": "-90.0714649",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-992-8475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-56e9-7548-827f-1ef8770dc084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-56e9-7548-827f-1ef8770dc084",
        "storage_key": "property/6767906449165610/019d2709-56e9-7548-827f-1ef8770dc084.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOQyEcrKIYRQCRTVZP4_ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_1895dbc2-dff8-41bb-963a-e67e9dbf9985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Renaissance at Colony Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "Open-air retail center with a European design theme, featuring fountains and lush landscaping.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and restaurants. They highlight the clean and well-maintained environment, and the beautiful fountains and water show. They also like the safe and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-307f-722a-9ad2-c0f8e572e8ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-307f-722a-9ad2-c0f8e572e8ce",
        "storage_key": "property/6767906449165610/019d2709-307f-722a-9ad2-c0f8e572e8ce.webp",
        "width": 701,
        "height": 396
      },
      "poi_business_url": "https://renaissanceatcolonypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1390767190390103411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renaissance-at-colony-park",
      "poi_latitude": "32.4356677",
      "poi_longitude": "-90.1465128",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-519-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-56e9-7548-827f-1ef8770dc084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-56e9-7548-827f-1ef8770dc084",
        "storage_key": "property/6767906449165610/019d2709-56e9-7548-827f-1ef8770dc084.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr8vq_wjSKYYRc114HGT_TBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_23cba6c5-353b-49a7-b15e-105094c74be4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Holmes Community College",
      "poi_type": "Education",
      "poi_address": "412 W Ridgeland Ave, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3164-7429-aff5-c1ce101f2a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3164-7429-aff5-c1ce101f2a63",
        "storage_key": "property/6767906449165610/019d2709-3164-7429-aff5-c1ce101f2a63.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://holmescc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907095702532732739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "holmes-community-college",
      "poi_latitude": "32.4371517",
      "poi_longitude": "-90.1391745",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-856-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-56ac-72d6-875b-96f7909c50fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-56ac-72d6-875b-96f7909c50fd",
        "storage_key": "property/6767906449165610/019d2709-56ac-72d6-875b-96f7909c50fd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RKR5BrSKYYRQzcXM_Lu2l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d80d2820-7a4e-47b8-817c-5ae5b7d896dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Tougaloo College",
      "poi_type": "Education",
      "poi_address": "500 W County Line Rd, Tougaloo, MS 39174, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-31d3-7108-bcaf-959af88024c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-31d3-7108-bcaf-959af88024c6",
        "storage_key": "property/6767906449165610/019d2709-31d3-7108-bcaf-959af88024c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tougaloo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573720754771851030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tougaloo-college",
      "poi_latitude": "32.4048193",
      "poi_longitude": "-90.160845",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-977-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-56ac-72d6-875b-96f7909c50fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-56ac-72d6-875b-96f7909c50fd",
        "storage_key": "property/6767906449165610/019d2709-56ac-72d6-875b-96f7909c50fd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJewwN-pzNKYYRFve9zbQdnqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6fc2ac04-3079-4da6-8322-f97c838da618",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "6370 Ridgewood Ct Dr, Jackson, MS 39211, USA",
      "poi_short_description": "Trampoline park featuring multiple jumping areas, plus go-karts, arcade games and a zip line.",
      "poi_long_description": "People say this amusement park offers a variety of exciting activities, including trampolines, go-karts, bumper cars, and a zip line. They highlight the fun, family-friendly atmosphere and the spacious layout with plenty of activities for kids. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3475-75ee-b97b-5b35549eccd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3475-75ee-b97b-5b35549eccd3",
        "storage_key": "property/6767906449165610/019d2709-3475-75ee-b97b-5b35549eccd3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/mississippi-jackson/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3514114226054270296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.3958583",
      "poi_longitude": "-90.1364822",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-566-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9gZoZjTKYYRWI0cIEWkxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_294e736c-e9b8-4b44-a31a-750c17094bf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "2000 E County Line Rd Suite B, Ridgeland, MS 39157, USA",
      "poi_short_description": "Bounce-filled amusement center featuring a trampoline park with dodgeball and basketball courts, plus arcade games.",
      "poi_long_description": "People say this amusement park offers a fun experience for kids and birthday parties. They also highlight the professional and friendly staff, and the positive and welcoming atmosphere.\n\nOther reviews mention the food can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-35cb-759e-a5a5-26e84dc73abd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-35cb-759e-a5a5-26e84dc73abd",
        "storage_key": "property/6767906449165610/019d2709-35cb-759e-a5a5-26e84dc73abd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.skyzone.com/ridgeland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573673565696973962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "32.400928",
      "poi_longitude": "-90.109942",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-899-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8_ZewDTKYYRilxCW5jNINg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_7a807d8e-4b63-45d4-a1bd-86ab8bce2b8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Mississippi Agriculture and Forestry Museum",
      "poi_type": "Entertainment",
      "poi_address": "1150 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "A living-history farm, a recreated 1920s cotton-economy-era town & local historical artifacts.",
      "poi_long_description": "Visitors say this museum features antique equipment, tools, cars, and planes, as well as a recreated old town with a doctor's office, gas station, and schoolhouse. They also highlight the special events, such as the Pickle Festival and pumpkin patch, that the museum hosts throughout the year.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-36c8-7048-a392-725edac39dbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-36c8-7048-a392-725edac39dbe",
        "storage_key": "property/6767906449165610/019d2709-36c8-7048-a392-725edac39dbe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.msagmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7687106239260140894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mississippi-agriculture-and-forestry-museum",
      "poi_latitude": "32.3366165",
      "poi_longitude": "-90.1577225",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-432-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5b09-742d-ade4-1cfd851a9782.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5b09-742d-ade4-1cfd851a9782",
        "storage_key": "property/6767906449165610/019d2709-5b09-742d-ade4-1cfd851a9782.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yEzu6IyKIYRXiXKhWUWrmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2d508a52-5a36-46ed-8f4b-8436de55bb5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "DEFY Jackson",
      "poi_type": "Entertainment",
      "poi_address": "2280 Lakeland Dr, Jackson, MS 39232, USA",
      "poi_short_description": "Kid-friendly bounce center with a ninja-style obstacle course, dodgeball and foam pits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3777-73ab-b9dd-09d6861ce3c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3777-73ab-b9dd-09d6861ce3c5",
        "storage_key": "property/6767906449165610/019d2709-3777-73ab-b9dd-09d6861ce3c5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://defy.com/defy-jackson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10670914183626614326&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "defy-jackson",
      "poi_latitude": "32.3315296",
      "poi_longitude": "-90.12563",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 769-208-3008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRfI-xUtKIYRNua9v-mzFpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a6b4dccc-a726-497e-a86d-d3e44977d648",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Smith-Wills Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1200 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "Stadium hosting fireworks displays, games and concerts, plus other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-397f-7194-ade1-3ff223a48c3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-397f-7194-ade1-3ff223a48c3d",
        "storage_key": "property/6767906449165610/019d2709-397f-7194-ade1-3ff223a48c3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=385897145946479173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "smith-wills-stadium",
      "poi_latitude": "32.336819",
      "poi_longitude": "-90.153487",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-362-2294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5b76-716c-a642-2452997e825c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5b76-716c-a642-2452997e825c",
        "storage_key": "property/6767906449165610/019d2709-5b76-716c-a642-2452997e825c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd5hrcKEyKIYRRRr632j7WgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_4f4babec-c911-4e15-9e1e-deb632a8e762",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "772 Lake Harbour Dr # 1, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clean gym chain featuring a cardio area, weight machines and a 24-hour schedule.",
      "poi_long_description": "People say this gym has a wide variety of well-maintained equipment, including treadmills, ellipticals, bikes, rowing machines, and weight machines, and they appreciate the spacious layout. They also highlight the friendly and helpful staff, and the clean and well-lit facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3b3d-7530-93c1-63f108e25ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3b3d-7530-93c1-63f108e25ed4",
        "storage_key": "property/6767906449165610/019d2709-3b3d-7530-93c1-63f108e25ed4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/ridgeland-ms?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17295786995903098070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.4155597",
      "poi_longitude": "-90.1107937",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-427-5901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSGVmpnTKYYR1uyfwaL6BvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2e1fa9b8-3dd1-4988-907a-a0265ca7cf93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "175 Grandview Blvd, Madison, MS 39110, USA",
      "poi_short_description": "Chain specializing in cosmetics, hair products and skincare items.",
      "poi_long_description": "People say this cosmetics store offers great customer service with helpful and friendly staff. They also highlight that customers can find everything they need.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3b20-738c-a138-42ea5cd6a9ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3b20-738c-a138-42ea5cd6a9ab",
        "storage_key": "property/6767906449165610/019d2709-3b20-738c-a138-42ea5cd6a9ab.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/madison-ms-477",
      "poi_directions_map_url": "https://maps.google.com/?cid=14503229940897169379&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "32.4648393",
      "poi_longitude": "-90.1350921",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-856-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_wdLgHdKIYR4z_8MsrSRck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_0ae29340-e4fd-46cf-a345-0888380870ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "GRIT Training",
      "poi_type": "Health and Wellness",
      "poi_address": "2625 Courthouse Cir, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, including a batting cage, workout field, pool, basketball court, free weights, and machines. They highlight the spacious layout, cool vibe, and excellent equipment. They also like the friendly staff and clean, safe, family environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3cdc-755e-9bfd-edb5c6219274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3cdc-755e-9bfd-edb5c6219274",
        "storage_key": "property/6767906449165610/019d2709-3cdc-755e-9bfd-edb5c6219274.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.grit-ms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2231842918902481768&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grit-training",
      "poi_latitude": "32.3272575",
      "poi_longitude": "-90.1152147",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-487-2443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6cx-GwtKIYRaEOnV08Z-R4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_c33cd91a-fbb3-404c-9d9b-ec6d4e3f6fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "CLUB4 Fitness Lake Harbour",
      "poi_type": "Health and Wellness",
      "poi_address": "511 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Membership-only gym offering equipment, classes, child care, a pool, and a rock climbing wall.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, classes, and instructors, and is a great place to achieve fitness goals. They also highlight the friendly staff, clean facility, and reasonable membership prices.\n\nOther reviews mention the lockers can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3efb-7601-ac27-2c1dc9b266a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3efb-7601-ac27-2c1dc9b266a1",
        "storage_key": "property/6767906449165610/019d2709-3efb-7601-ac27-2c1dc9b266a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.club4fitness.com/location/lake-harbour/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6318120847339163222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club4-fitness-lake-harbour",
      "poi_latitude": "32.4133465",
      "poi_longitude": "-90.1175495",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 601-605-9886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTFhXUPSKYYRVg6kkW95rlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2ec4ca0a-dcc9-45d7-8ca5-9d20f9d4d228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Animal Emergency & Referral Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1009 Treetops Blvd, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-3f83-770b-a45f-70dac6f036db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3f83-770b-a45f-70dac6f036db",
        "storage_key": "property/6767906449165610/019d2709-3f83-770b-a45f-70dac6f036db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cvm.msstate.edu/aerc-home",
      "poi_directions_map_url": "https://maps.google.com/?cid=12162414471896174386&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency--referral-center",
      "poi_latitude": "32.3255648",
      "poi_longitude": "-90.1194963",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-939-8999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzq8QxotKIYRMg9x4IWTyag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_fd3855d1-cc1c-435d-bc88-9a072ee2e68e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Crunch Fitness - Ridgeland",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Fitness center featuring various classes (including spinning), treadmills, weights and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-4030-745b-a3e5-9c2c726537f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4030-745b-a3e5-9c2c726537f7",
        "storage_key": "property/6767906449165610/019d2709-4030-745b-a3e5-9c2c726537f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/ridgeland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16000032341730509397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---ridgeland",
      "poi_latitude": "32.4010391",
      "poi_longitude": "-90.1096038",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-360-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfpJ8fjSKYYRVcKbm6SIC94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ced92289-911e-45d1-860d-dc6e7603218d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Flowood - Lakeland Drive",
      "poi_type": "Health and Wellness",
      "poi_address": "163 Ridge Way E, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-41da-7725-a707-9394d33a0360.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-41da-7725-a707-9394d33a0360",
        "storage_key": "property/6767906449165610/019d2709-41da-7725-a707-9394d33a0360.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-ms-flowood-ms101?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9886910044159362539&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-flowood---lakeland-drive",
      "poi_latitude": "32.3395694",
      "poi_longitude": "-90.0703666",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-992-2733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfbKwFsrKIYR60VcVE1cNYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_68386ba2-a8ba-4388-a8c9-5b80e245e49f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Madison Healthplex Performance Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Baptist Dr, Madison, MS 39110, USA",
      "poi_short_description": "Large gym with a pool, hot tub, and cold plunge, plus a variety of group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-43f6-7648-b554-6af0994eca45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-43f6-7648-b554-6af0994eca45",
        "storage_key": "property/6767906449165610/019d2709-43f6-7648-b554-6af0994eca45.webp",
        "width": 981,
        "height": 768
      },
      "poi_business_url": "http://www.healthplexperformance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10695343614279382681&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-healthplex-performance-training-center",
      "poi_latitude": "32.470621",
      "poi_longitude": "-90.1372865",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-856-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0v5kMLRKYYRmXbdz1l-bZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b416cf8f-01f7-4e75-a5ad-881ec6d9f066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Merit Health River Oaks",
      "poi_type": "Health and Wellness",
      "poi_address": "1030 River Oaks Dr, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-445e-760e-86a6-650761efabf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-445e-760e-86a6-650761efabf9",
        "storage_key": "property/6767906449165610/019d2709-445e-760e-86a6-650761efabf9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.merithealthriveroaks.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11758755380568636959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "merit-health-river-oaks",
      "poi_latitude": "32.3255013",
      "poi_longitude": "-90.1052711",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-932-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5c84-740d-95a9-1efe61b73291.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c84-740d-95a9-1efe61b73291",
        "storage_key": "property/6767906449165610/019d2709-5c84-740d-95a9-1efe61b73291.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdk8UuQsKIYRH76B07d9L6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_133679ac-0838-465c-8047-825fd40b4b13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Children's Medical Group",
      "poi_type": "Health and Wellness",
      "poi_address": "1867 Crane Ridge Dr #101b, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-44da-750a-b99e-9c312fa0262d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-44da-750a-b99e-9c312fa0262d",
        "storage_key": "property/6767906449165610/019d2709-44da-750a-b99e-9c312fa0262d.webp",
        "width": 820,
        "height": 312
      },
      "poi_business_url": "https://childrensmedicalgroup.net/jackson-after-hours/?utm_source=jackson&utm_medium=organic&utm_content=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8251115455065695625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childrens-medical-group",
      "poi_latitude": "32.331518",
      "poi_longitude": "-90.1382934",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-362-8776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5c84-740d-95a9-1efe61b73291.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5c84-740d-95a9-1efe61b73291",
        "storage_key": "property/6767906449165610/019d2709-5c84-740d-95a9-1efe61b73291.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP41mRWgtKIYRiSXtQ8rZgXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_81ed86a7-c364-43db-b3c0-378e34d55aab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "LeFleur's Bluff State Park Mayes Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3315 Lakeland Terrace, Jackson, MS 39216, USA",
      "poi_short_description": "State park offering hiking, disc golf, a playground, and campgrounds, plus a natural science museum.",
      "poi_long_description": "People say this state park offers a campground, fishing, and trails, and is conveniently located near the city. They highlight the affordable prices, quiet and peaceful vibe, and the opportunity to see wildlife. They also like the friendly staff and the well-maintained bathrooms with free showers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-466d-77bc-af64-2c0999a3ff3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-466d-77bc-af64-2c0999a3ff3b",
        "storage_key": "property/6767906449165610/019d2709-466d-77bc-af64-2c0999a3ff3b.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.mdwfp.com/parks-destinations/park/lefleurs-bluff-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18333674287180082174&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lefleurs-bluff-state-park-mayes-lake",
      "poi_latitude": "32.3308055",
      "poi_longitude": "-90.1489668",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-987-3923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5f77-724d-92d4-378e268cb915",
        "storage_key": "property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTspAmItKIYR_usU06BLbv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_62675a6f-d875-46b5-9605-b3041272c269",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Freedom Ridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "253 W School St, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clean sports-facility park featuring a softball field and a playground.",
      "poi_long_description": "People say this park is very big and fun for kids, and also great for soccer games. They highlight the clean and friendly environment, and the easy access between fields. They also like that it's safe. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-4944-7644-96ee-94ba512456ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4944-7644-96ee-94ba512456ce",
        "storage_key": "property/6767906449165610/019d2709-4944-7644-96ee-94ba512456ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridgelandms.org/city-departments/recreation-and-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15546985984956168474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freedom-ridge",
      "poi_latitude": "32.4197477",
      "poi_longitude": "-90.1413081",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5f77-724d-92d4-378e268cb915",
        "storage_key": "property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSKa83HSKYYRGvlJwWH9wdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a5cb9964-56c8-44ef-a482-68ff0ea099c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Winners Circle Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Winners Cir, Flowood, MS 39232, USA",
      "poi_short_description": "Clean recreation area featuring a playground, tennis courts, barbecue grills and walking paths.",
      "poi_long_description": "Visitors say this park has well-maintained playgrounds and tennis courts, and they appreciate the beautiful nature. They also highlight that the playground is suitable for all ages, making it a great spot for families with young children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-49ca-76c7-8901-ff4a5ab6931f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-49ca-76c7-8901-ff4a5ab6931f",
        "storage_key": "property/6767906449165610/019d2709-49ca-76c7-8901-ff4a5ab6931f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofflowood.com/winner%E2%80%99s-circle-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4454325228718501489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winners-circle-park",
      "poi_latitude": "32.3470087",
      "poi_longitude": "-90.0625008",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-992-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5f77-724d-92d4-378e268cb915",
        "storage_key": "property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9jH-04rKIYRca7TCzLx0D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_82bc9a3a-4467-442c-bade-c1abc1f50367",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Old Trace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "422 Post Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Park with a playground, picnic areas, restrooms, walking trails, and a disc golf course.",
      "poi_long_description": "People say this park offers a beautiful view of the reservoir. They highlight the dog park and walking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-495e-74ba-a44f-20c96dc7ba7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-495e-74ba-a44f-20c96dc7ba7b",
        "storage_key": "property/6767906449165610/019d2709-495e-74ba-a44f-20c96dc7ba7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.therez.ms.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671602723425758356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-trace-park",
      "poi_latitude": "32.4274039",
      "poi_longitude": "-90.0823689",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5f77-724d-92d4-378e268cb915",
        "storage_key": "property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfITFPPTKYYRlCzCroVwEyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_54fd79a0-84a9-4e26-81f8-8c743320b75f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Flowood Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4077 Flowood Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Relaxed space, home to a 1-mile loop trail, for walkingand running, plus picnic spots.",
      "poi_long_description": "People say this park offers beautiful walking trails and pavilions for picnics and resting. They highlight the peaceful and serene atmosphere, and the clean and well-maintained environment. They also like the informative signage along the trails. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-4b58-7296-a169-258b9913d7b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4b58-7296-a169-258b9913d7b3",
        "storage_key": "property/6767906449165610/019d2709-4b58-7296-a169-258b9913d7b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofflowood.com/flowood-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6452044323503789375&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flowood-nature-park",
      "poi_latitude": "32.348192",
      "poi_longitude": "-90.0582452",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-992-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5f77-724d-92d4-378e268cb915",
        "storage_key": "property/6767906449165610/019d2709-5f77-724d-92d4-378e268cb915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnaXwdEkrKIYRP9WEuSBEilk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_051b755c-b701-40a2-b81a-f12316dbd5cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Bruce Campbell Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-4df6-7538-a81a-5ce6411755fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4df6-7538-a81a-5ce6411755fd",
        "storage_key": "property/6767906449165610/019d2709-4df6-7538-a81a-5ce6411755fd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.madisonthecity.com/government/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202379395653693271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bruce-campbell-field",
      "poi_latitude": "32.4400825",
      "poi_longitude": "-90.1052932",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5eed-7423-8779-2d5e15611543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5eed-7423-8779-2d5e15611543",
        "storage_key": "property/6767906449165610/019d2709-5eed-7423-8779-2d5e15611543.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRqzhNDTKYYRV-9P1k1rtX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ada955d1-406f-4139-b349-e58fb60f00f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Madison Air LLC.",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-4ed2-70ec-9739-2ec72f78641e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4ed2-70ec-9739-2ec72f78641e",
        "storage_key": "property/6767906449165610/019d2709-4ed2-70ec-9739-2ec72f78641e.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11203969235679198100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-air-llc",
      "poi_latitude": "32.4401776",
      "poi_longitude": "-90.1051652",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5eed-7423-8779-2d5e15611543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5eed-7423-8779-2d5e15611543",
        "storage_key": "property/6767906449165610/019d2709-5eed-7423-8779-2d5e15611543.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYe6J9HTKYYRlDsQn6h-fJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3b122de3-6362-4026-b8cc-9a26d8539ee1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "The Powerhouse, Entergy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Echelon Pkwy, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-4fc3-71ff-a99d-feab86ec2be8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4fc3-71ff-a99d-feab86ec2be8",
        "storage_key": "property/6767906449165610/019d2709-4fc3-71ff-a99d-feab86ec2be8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8770278893550025776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-powerhouse-entergy",
      "poi_latitude": "32.396321",
      "poi_longitude": "-90.191046",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-952-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaisuv7MKYYRMLwnzy9Ktnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9bb2cdad-10b8-4586-990c-582f1643532a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Entergy Transmission HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6540 Watkins Dr, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-516c-704d-9783-7e9972df3e86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-516c-704d-9783-7e9972df3e86",
        "storage_key": "property/6767906449165610/019d2709-516c-704d-9783-7e9972df3e86.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://entergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1578563261303676078&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "entergy-transmission-hq",
      "poi_latitude": "32.3975051",
      "poi_longitude": "-90.1912372",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2H9zv7MKYYRrtx8Lewu6BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f1d519e1-996d-4cc2-873c-937b06c9aa1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "C Spire Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1018 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5231-7209-ab60-5fc1a641965c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5231-7209-ab60-5fc1a641965c",
        "storage_key": "property/6767906449165610/019d2709-5231-7209-ab60-5fc1a641965c.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.cspire.com/business",
      "poi_directions_map_url": "https://maps.google.com/?cid=8383002471184058399&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "c-spire-corporate-headquarters",
      "poi_latitude": "32.437348",
      "poi_longitude": "-90.147231",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 866-455-9628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0s2rPXTKYYRH8glHlVoVnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_90d9be40-770e-47a5-be77-13d526199b18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "MDHS- Child Support Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "950 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mdhs.ms.gov/child-support/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1738695405663311359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mdhs--child-support-services",
      "poi_latitude": "32.4004974",
      "poi_longitude": "-90.1374969",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-359-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu1njEqnTKYYR_1Uqa0IWIRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1930abd0-2fb6-423c-9426-993a130b2daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "WIS International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "405 Briarwood Dr Ste 204, Jackson, MS 39206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=723603429317288698&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wis-international",
      "poi_latitude": "32.3788088",
      "poi_longitude": "-90.1517332",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-957-0181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5a99-73be-90dd-ab9350bc4a33",
        "storage_key": "property/6767906449165610/019d2709-5a99-73be-90dd-ab9350bc4a33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-630XmDNKYYR-iK2MnzBCgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c48a7e4c-e855-42a0-b2e9-b81119de2fae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Ann Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "306 S Pear Orchard Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-9bef-70f5-8455-ded2ef1a11d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9bef-70f5-8455-ded2ef1a11d9",
        "storage_key": "property/6767906449165610/019d7912-9bef-70f5-8455-ded2ef1a11d9.webp",
        "width": 533,
        "height": 400
      },
      "poi_business_url": "http://www.madison-schools.com/ase",
      "poi_directions_map_url": "https://maps.google.com/?cid=2820663062739685371&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ann-smith-elementary-school",
      "poi_latitude": "32.420476",
      "poi_longitude": "-90.1220605",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-856-6621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3869-7741-87ae-242425864a8b",
        "storage_key": "property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6yCSN0bSKYYR-w-qbRwCJSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9f80f918-2111-462a-8d47-4902e8dfa761",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Madison Avenue Elementary School",
      "poi_type": "Education",
      "poi_address": "1199 Madison Ave, Madison, MS 39110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.madison-schools.com/Domain/475",
      "poi_directions_map_url": "https://maps.google.com/?cid=1751338379721322193&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "madison-avenue-elementary-school",
      "poi_latitude": "32.4559844",
      "poi_longitude": "-90.0943236",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-856-2951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3869-7741-87ae-242425864a8b",
        "storage_key": "property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy-aVl2fRKYYR0S7MNPoAThg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b02396a6-d528-4aad-b938-f457e7e92168",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Madison Station Elementary",
      "poi_type": "Education",
      "poi_address": "459 Reunion Pkwy, Madison, MS 39110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-9d2d-706a-b3d4-c298d75a5c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9d2d-706a-b3d4-c298d75a5c95",
        "storage_key": "property/6767906449165610/019d7912-9d2d-706a-b3d4-c298d75a5c95.webp",
        "width": 450,
        "height": 300
      },
      "poi_business_url": "http://www.madison-schools.com/mse",
      "poi_directions_map_url": "https://maps.google.com/?cid=15194542387058779835&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "madison-station-elementary",
      "poi_latitude": "32.4940406",
      "poi_longitude": "-90.1512542",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-856-6246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3869-7741-87ae-242425864a8b",
        "storage_key": "property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq5rZDTDQKYYRuyZBAczb3dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7be3688c-e97c-49aa-8717-c7fb41576889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Highland Elementary School",
      "poi_type": "Education",
      "poi_address": "330 Brame Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.madison-schools.com/hes",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494384500546725945&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highland-elementary-school",
      "poi_latitude": "32.4161238",
      "poi_longitude": "-90.1505377",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-853-8103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3869-7741-87ae-242425864a8b",
        "storage_key": "property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJddIAM4rNKYYROehnSJwcB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1d77f920-48cc-47df-bffc-5a258f0634b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Ridgeland High School",
      "poi_type": "Education",
      "poi_address": "586 Sunnybrook Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-9c38-7217-8149-100dc718c825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9c38-7217-8149-100dc718c825",
        "storage_key": "property/6767906449165610/019d7912-9c38-7217-8149-100dc718c825.webp",
        "width": 440,
        "height": 400
      },
      "poi_business_url": "https://rhs.madison-schools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3513983871240866136&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgeland-high-school",
      "poi_latitude": "32.4445543",
      "poi_longitude": "-90.1360819",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-898-5023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3869-7741-87ae-242425864a8b",
        "storage_key": "property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOYANuB3SKYYRWInDh7YtxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_880de097-6cef-4092-b6f5-803488633244",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "St Andrew's Episcopal School- North Campus",
      "poi_type": "Education",
      "poi_address": "370 Old Agency Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-9e6b-72ea-96f9-bfc2838987fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9e6b-72ea-96f9-bfc2838987fa",
        "storage_key": "property/6767906449165610/019d7912-9e6b-72ea-96f9-bfc2838987fa.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.gosaints.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2185204927122039813&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "st-andrew-s-episcopal-school-north-campus",
      "poi_latitude": "32.4353536",
      "poi_longitude": "-90.1501893",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-853-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3869-7741-87ae-242425864a8b",
        "storage_key": "property/6767906449165610/019cfb42-3869-7741-87ae-242425864a8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT6i4tQ7SKYYRBeSKsk1oUx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5106f711-0af8-4e28-8c84-319390635d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "764 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "People say this restaurant provides delicious food with nice portions.\n\nOther reviews mention the service can be slow and the staff can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-a51c-77dc-b523-12f7ce93a337.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a51c-77dc-b523-12f7ce93a337",
        "storage_key": "property/6767906449165610/019d7912-a51c-77dc-b523-12f7ce93a337.webp",
        "width": 1280,
        "height": 1259
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/ms/ridgeland/764-lake-harbour-drive-76037?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=76037&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=12482220686730676005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "applebee-s-grill-bar",
      "poi_latitude": "32.4145102",
      "poi_longitude": "-90.1100784",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-707-1784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3857-762a-b842-aaf9b3302752",
        "storage_key": "property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0yfk87LTKYYRJUeduJTBOa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3afb16c8-089f-4556-863e-3191e03d4fdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "808 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "People say this chicken wings restaurant serves delicious wings and burgers. They also highlight the fun, sports bar vibe and the friendly staff.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-a2a2-76dc-8c0a-ff0b0598cfb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a2a2-76dc-8c0a-ff0b0598cfb5",
        "storage_key": "property/6767906449165610/019d7912-a2a2-76dc-8c0a-ff0b0598cfb5.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/ms/ridgeland/808-lake-harbour-drive/sports-bar-324/?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMTU3OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1163869777832750754&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "32.4146682",
      "poi_longitude": "-90.1046742",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-856-0789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3857-762a-b842-aaf9b3302752",
        "storage_key": "property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_SZBi7LTKYYRoq6IgGXlJhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_cac2e7ea-db7b-4602-826f-ea14896bf893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Rock N Roll Sushi",
      "poi_type": "Restaurants",
      "poi_address": "733 Lake Harbour Dr suite k, Ridgeland, MS 39157, USA",
      "poi_short_description": "Rolls and other Japanese fare served with rock 'n' roll music in a casual restaurant.",
      "poi_long_description": "People say this sushi restaurant offers fresh and delicious sushi rolls, wontons, and pot stickers. They highlight the reasonable prices and fun, rock and roll vibe. They also like the quick and friendly service, and the attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-a960-74dc-bda9-43d06060ffa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a960-74dc-bda9-43d06060ffa3",
        "storage_key": "property/6767906449165610/019d7912-a960-74dc-bda9-43d06060ffa3.webp",
        "width": 1083,
        "height": 1280
      },
      "poi_business_url": "https://rocknrollsushi.com/locations/ridgeland-ms/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17431853443219367889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-n-roll-sushi",
      "poi_latitude": "32.4130767",
      "poi_longitude": "-90.1123115",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 769-300-1911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3857-762a-b842-aaf9b3302752",
        "storage_key": "property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0U18wk3TKYYR0afCQ1li6vE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_ddbf5738-0152-417b-b71b-ca3e3c4b1523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Primos Cafe",
      "poi_type": "Restaurants",
      "poi_address": "515 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Casual restaurant serving Southern American fare in diner-like digs with a bakery counter.",
      "poi_long_description": "People say this restaurant offers delicious food, including burgers, fries, and sweet tea, and a wide variety of bakery items. They also highlight the friendly and helpful staff, and the clean and spacious atmosphere.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-a502-72ef-9752-1cdd9da1733b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a502-72ef-9752-1cdd9da1733b",
        "storage_key": "property/6767906449165610/019d7912-a502-72ef-9752-1cdd9da1733b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.primoscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4860481428203367308&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "primos-cafe",
      "poi_latitude": "32.4136154",
      "poi_longitude": "-90.1166822",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-898-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3857-762a-b842-aaf9b3302752",
        "storage_key": "property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2W7EC07SKYYRjOtxZRvmc0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7a3c2aa2-3f6b-4854-a1c6-eaa3aae1481a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Mama Nature's Juice Bar",
      "poi_type": "Restaurants",
      "poi_address": "655 Lake Harbour Dr Suite 400, Ridgeland, MS 39157, USA",
      "poi_short_description": "Juice shop offering smoothies, bowls, avocado toast, and other health-minded fare inside Charmant Station.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-ab8f-742d-b56d-ab7fb3ee0d10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ab8f-742d-b56d-ab7fb3ee0d10",
        "storage_key": "property/6767906449165610/019d7912-ab8f-742d-b56d-ab7fb3ee0d10.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8024917326304954080&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mama-nature-s-juice-bar",
      "poi_latitude": "32.4135111",
      "poi_longitude": "-90.1156778",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-499-4936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3857-762a-b842-aaf9b3302752",
        "storage_key": "property/6767906449165610/019cfb42-3857-762a-b842-aaf9b3302752.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTKMkk3SKYYR4MZIWso7Xm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_475b1a19-b684-41ce-8e3d-aa8fec6474df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "7045 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store has a wonderful produce selection. They also highlight the fresh items.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-ad34-7219-bc5d-0f4d9be66354.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ad34-7219-bc5d-0f4d9be66354",
        "storage_key": "property/6767906449165610/019d7912-ad34-7219-bc5d-0f4d9be66354.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ms/ridgeland/old-canton-ridgeland/025/00494?cid=loc_02500494_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3490720205170081491&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.4159341",
      "poi_longitude": "-90.1070865",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-856-3442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-386a-7618-87eb-f5d330bd6a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-386a-7618-87eb-f5d330bd6a9a",
        "storage_key": "property/6767906449165610/019cfb42-386a-7618-87eb-f5d330bd6a9a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdSteLHTKYYR0_5wL4iHcTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a2bc0922-8e29-444d-ad57-8275a5eed87b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "815 S Wheatley St, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain department store offering a selection of merchandise, including furniture, clothing, and electronics.",
      "poi_long_description": "People say this department store offers a large selection of quality products and reasonable prices.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-ae39-756e-baea-2c852d02701d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ae39-756e-baea-2c852d02701d",
        "storage_key": "property/6767906449165610/019d7912-ae39-756e-baea-2c852d02701d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/875-ridgeland-ms/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17328793411972118502&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.4017143",
      "poi_longitude": "-90.1339645",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-956-2717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3858-7586-b677-8e558f72bc9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3858-7586-b677-8e558f72bc9f",
        "storage_key": "property/6767906449165610/019cfb42-3858-7586-b677-8e558f72bc9f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYUshPGDSKYYR5je62ss9fPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a2267809-9bf7-46f1-b369-39489ddb8865",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "910 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a great selection of appliances and a large plumbing department. They also highlight the friendly, helpful, and knowledgeable staff.\n\nSome reviews mention the customer service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-22fe-7150-93ed-466a7e9fb5ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb42-22fe-7150-93ed-466a7e9fb5ed",
        "storage_key": "property/6767906449165610/019cfb42-22fe-7150-93ed-466a7e9fb5ed.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MS-Ridgeland/2622?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2622-_-na-_-0-_-0&y_source=1_MTE4MzYzNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17807805554163887672&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "32.400629",
      "poi_longitude": "-90.138947",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-952-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3858-7586-b677-8e558f72bc9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3858-7586-b677-8e558f72bc9f",
        "storage_key": "property/6767906449165610/019cfb42-3858-7586-b677-8e558f72bc9f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs2lTPYjSKYYROK4qPc0IIvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c5ee07ea-f78c-4cb5-bb1a-67f202130f53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "6970 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-b4be-7787-aa19-ecde8f71c0c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b4be-7787-aa19-ecde8f71c0c2",
        "storage_key": "property/6767906449165610/019d7912-b4be-7787-aa19-ecde8f71c0c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6970+old+canton+rd-ridgeland-ms-39157/id=5655",
      "poi_directions_map_url": "https://maps.google.com/?cid=9055436334782902824&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.4133597",
      "poi_longitude": "-90.1057689",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-956-3844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-385e-722c-b601-ea0e24ffaf2a",
        "storage_key": "property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeS-3xLHTKYYRKHLmZF5fq30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8ec7217c-c93a-4a40-b341-bc05b42d8ce5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Freshway Produce",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Fresh locally grown produce ranging from pumpkins and Christmas trees to jam and honey.",
      "poi_long_description": "People say this farmers market offers fresh produce, fun foods, and a wide selection of dips, dressings, marinades, jams, and pickled items. They highlight the great quality and freshness of the fruits and vegetables, and the large variety of offerings. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-b4a2-73cc-b09b-32c774dbfa5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b4a2-73cc-b09b-32c774dbfa5b",
        "storage_key": "property/6767906449165610/019d7912-b4a2-73cc-b09b-32c774dbfa5b.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17543464259229228474&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "freshway-produce",
      "poi_latitude": "32.4107111",
      "poi_longitude": "-90.1058651",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-956-3727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3858-7586-b677-8e558f72bc9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3858-7586-b677-8e558f72bc9f",
        "storage_key": "property/6767906449165610/019cfb42-3858-7586-b677-8e558f72bc9f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD3nvwklLnYgRup0eZcvndvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_c586293d-f4b6-498d-a2e9-bd168fca142c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Ross R Barnett Reservoir",
      "poi_type": "Entertainment",
      "poi_address": "Ross R Barnett Reservoir, Mississippi, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-b627-763a-b4ba-6d76979be346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b627-763a-b4ba-6d76979be346",
        "storage_key": "property/6767906449165610/019d7912-b627-763a-b4ba-6d76979be346.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3494620874599894286&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-r-barnett-reservoir",
      "poi_latitude": "32.4580438",
      "poi_longitude": "-90.0279867",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-385e-722c-b601-ea0e24ffaf2a",
        "storage_key": "property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3zz6QLWKYYRDg0xjytjfzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lake"
    },
    {
      "id": "custom_9ea0bcf5-2be6-4554-a39f-17cbf5189cd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Friendship Park",
      "poi_type": "Entertainment",
      "poi_address": "475 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed park with a playground, swings, slides and fitness equipment plus picnic tables and walking trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-b71d-7478-94d1-4b1bf40c2901.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b71d-7478-94d1-4b1bf40c2901",
        "storage_key": "property/6767906449165610/019d7912-b71d-7478-94d1-4b1bf40c2901.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.ridgelandms.org/city-departments/recreation-and-parks/facilities/#Friendship-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12704319735673983707&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "32.412771",
      "poi_longitude": "-90.1208439",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3850-7697-b551-4ef269e950c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3850-7697-b551-4ef269e950c8",
        "storage_key": "property/6767906449165610/019cfb42-3850-7697-b551-4ef269e950c8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Rc3SLXTKYYR2xLVPX3PTrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b06ed995-dc93-495b-8025-f29114f55a8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "B&B Theatres Ridgeland Northpark 14",
      "poi_type": "Entertainment",
      "poi_address": "250 Ring Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "People say this movie theater offers comfortable seating and a luxurious, up-to-date atmosphere.\n\nOther reviews mention the movie experience can be disrupted by technical issues and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-bc78-77a8-b719-2d15b4b5ae39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bc78-77a8-b719-2d15b4b5ae39",
        "storage_key": "property/6767906449165610/019d7912-bc78-77a8-b719-2d15b4b5ae39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x02x0-b-and-b-theatres-ridgeland-northpark-14/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16856495913629596744&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "b-b-theatres-ridgeland-northpark-14",
      "poi_latitude": "32.40563789999999",
      "poi_longitude": "-90.1294076",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-202-9890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-f18e-7720-8b27-103569396b32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-f18e-7720-8b27-103569396b32",
        "storage_key": "property/6767906449165610/019d7912-f18e-7720-8b27-103569396b32.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9RvCY3TKYYRSDy3UblN7uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e9fc3c53-84e2-4eae-9f48-cf5923ab156e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Deerfield Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "264 Deerfield Club Dr, Canton, MS 39046, USA",
      "poi_short_description": "Well-maintained club and course featuring a restaurant and a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-be14-739c-8b1c-b897224d450d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-be14-739c-8b1c-b897224d450d",
        "storage_key": "property/6767906449165610/019d7912-be14-739c-8b1c-b897224d450d.webp",
        "width": 1280,
        "height": 755
      },
      "poi_business_url": "https://deerfieldgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6632587797004017318&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "deerfield-golf-club",
      "poi_latitude": "32.5225258",
      "poi_longitude": "-90.0287914",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 601-856-6966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-385e-722c-b601-ea0e24ffaf2a",
        "storage_key": "property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bmj05vXKYYRpt4D3nWvC1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_d5dc2de5-c50a-4c25-91db-7372114060bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Old Trace",
      "poi_type": "Entertainment",
      "poi_address": "Unnamed Road #39157, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-bfb9-7332-85d1-5cbebab486fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bfb9-7332-85d1-5cbebab486fd",
        "storage_key": "property/6767906449165610/019d7912-bfb9-7332-85d1-5cbebab486fd.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://npplan.com/parks-by-state/mississippi-national-parks/natchez-trace-parkway-park-at-a-glance/natchez-trace-parkway-hiking-trails/natchez-trace-parkway-old-trace-and-brashears-stand-mp-104-5/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989083696698533799&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-trace",
      "poi_latitude": "32.424649",
      "poi_longitude": "-90.0890086",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3850-7697-b551-4ef269e950c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3850-7697-b551-4ef269e950c8",
        "storage_key": "property/6767906449165610/019cfb42-3850-7697-b551-4ef269e950c8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XPJUOvTKYYRp6dQ4jTsA9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_746316f5-44ea-48a7-9ab5-df96f3e83e75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Simmons Arboretum",
      "poi_type": "Entertainment",
      "poi_address": "583 St Augustine Dr, Madison, MS 39110, USA",
      "poi_short_description": "Nature area featuring an arboretum and trails that are suitable for children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-c709-74ed-9921-1b3b5c70f32c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c709-74ed-9921-1b3b5c70f32c",
        "storage_key": "property/6767906449165610/019d7912-c709-74ed-9921-1b3b5c70f32c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.madisonthecity.com/residents/arboretum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=285302472750027286&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "simmons-arboretum",
      "poi_latitude": "32.4502989",
      "poi_longitude": "-90.0743779",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-853-9109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-385e-722c-b601-ea0e24ffaf2a",
        "storage_key": "property/6767906449165610/019cfb42-385e-722c-b601-ea0e24ffaf2a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0X2MavWKYYRFlLOXRaZ9QM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cc42f716-b89b-4fd8-a6a4-7324c8c649b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Delta National Forest",
      "poi_type": "Entertainment",
      "poi_address": "68 Frontage Rd, Rolling Fork, MS 39159, USA",
      "poi_short_description": "This swamplike natural area offers opportunities for primitive camping, fishing & ATV riding.",
      "poi_long_description": "This swamplike natural area offers opportunities for primitive camping, fishing & ATV riding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d7912-cdc2-75bb-a191-c78bc5c226f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cdc2-75bb-a191-c78bc5c226f5",
        "storage_key": "property/6767906449165610/019d7912-cdc2-75bb-a191-c78bc5c226f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fs.usda.gov/recarea/mississippi/recarea/?recid=82505",
      "poi_directions_map_url": "https://maps.google.com/?cid=9607797557821120218&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "delta-national-forest",
      "poi_latitude": "32.760815",
      "poi_longitude": "-90.7913247",
      "poi_miles_from_property": "77.6 mi",
      "poi_walking_minutes": "1 day 4 hours",
      "poi_biking_minutes": "5 hours 30 mins",
      "poi_driving_minutes": "1 hour 27 mins",
      "poi_business_phone": "+1 662-873-6256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-3850-7697-b551-4ef269e950c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-3850-7697-b551-4ef269e950c8",
        "storage_key": "property/6767906449165610/019cfb42-3850-7697-b551-4ef269e950c8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt7zoMIJtKYYR2h7Le_nAVYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "national_park"
    },
    {
      "id": "custom_6de222f7-9fd0-48e3-8216-3e8bf8d586c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "poi_name": "Olde Towne Middle School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "olde-towne-middle-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7f19ca3c91718aefcde4972a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b8ae728545dc110e1edb85ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f3b44b2ce83b7fa8d19aa54e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_da1216fb4748e4f0f4c0d57e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_fbf50e8e97ca4b802ac6e7af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b87d955b8fcf6cbec5074593",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_e1ee4b88a44494b47b66a694",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "rating": "5",
      "name": "Velvet Scott",
      "text": "Lived here for almost 3 years and here are my honest reviews.\n\n- Location: Right next to a gym, nail shop, a park, restaurants, and Kroger is within walking distance. Really quiet and safe neighborhood. Great place to raise kids. The apartment is also a voting precinct so in election days it’s easy for me to walk over rather than drive long distance (I’m from a rural county). There are also police officers living here along with night patrols which makes it even safer.\n\n- Management: My favorite part. Kerri was the previous manager and she was relatable and made us feel secure in any issue. Samantha, current manager, is the same. Always available to answer questions and get things done\n\n- Maintenance: our experience has been great. Mr. Eddie always goes above and beyond to fix any issue we have. We usually put in a request online via the portal. I understand some folks have mixed reviews which is understandable and I believe management is doing their best to hire more staff. If I ever feel like it’s taking longer than usual to resolve my issue I just kindly send a follow up or reach out to management\n\nCons: They do not have a 3 bedroom. Otherwise, I would renew 3 more years if I could.",
      "date": "2024-10-14",
      "title": "false"
    },
    {
      "id": "ec_77bb36a24db834d70ae3ae50",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "rating": "5",
      "name": "Shaani Jayarathne",
      "text": "Within a day, my maintenance request was resolved. Appreciate all the effort given us.",
      "date": "2025-10-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_515a5836-1b5a-47ae-a61c-00eac58cf0cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-9e89-7546-a3a4-f8fbc12067f8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of community common area with seating and kitchen island",
        "public_id": "019cfb42-9e89-7546-a3a4-f8fbc12067f8",
        "storage_key": "property/6767906449165610/019cfb42-9e89-7546-a3a4-f8fbc12067f8.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Mark of Ridgeland Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f43f19c2f006c46ba90ec93"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-411a-7209-8272-3c821f5dad57",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "mark-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610"
    },
    {
      "lead_collector_id": "019cf79e-418b-7572-820f-1bb88db96f3e",
      "lead_source": "LANDING_PAGE",
      "name": "mark-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "pool-apartments-ridgeland-ms-the-mark",
      "search_query": "pool apartments Ridgeland MS",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Ridgeland, MS",
      "h2_subtitle": "Discover your dream pool apartment at Mark Apts., located in Ridgeland, MS. Enjoy sun-filled days by the pool in this vibrant community.",
      "page_copy": "At Mark Apts. in Ridgeland, MS, residents enjoy a unique blend of comfort and convenience with our stunning pool apartments. Our sparkling pool provides a perfect retreat, allowing you to unwind and socialize with neighbors while basking in the warm Mississippi sun. \n\nLocated in the heart of Ridgeland, Mark Apts. offers an array of amenities including a vibrant clubhouse and spacious units with modern features. With options for one- and two-bedroom apartments, built-in bookshelves, and scenic balconies, you’ll find everything you need for a perfect lifestyle. Visit us today and see why our pool apartments in Ridgeland, MS are the ideal choice for comfortable living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Ridgeland, MS",
      "seo_description": "Experience comfort at Mark Apts. with pool apartments in Ridgeland, MS. Dive into leisure and luxury with top-notch amenities and modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-ridgeland-ms-the-mark",
      "search_query": "air conditioned apartments in Ridgeland Mississippi",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Ridgeland",
      "h2_subtitle": "Stay cool at Mark Apts. with our fully air-conditioned apartments in Ridgeland, Mississippi. Enjoy modern comfort in every room.",
      "page_copy": "Mark Apts. in Ridgeland, Mississippi, offers air-conditioned apartments that promise to keep you cool and comfortable year-round. Designed with modern conveniences and spacious interiors, these units ensure you experience the ultimate in comfort when temperatures rise.\n\nNestled in a desirable Ridgeland neighborhood, our community is more than just a place to live; it’s a lifestyle. Dive into relaxation at our sparkling pool, or enjoy social gatherings in our vibrant clubhouse. Each apartment features scenic balconies and built-in bookshelves, making it an extraordinary place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Ridgeland",
      "seo_description": "Stay cool at Mark Apts. with our air-conditioned apartments in Ridgeland, MS. Experience year-round comfort and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-madison-county-the-mark",
      "search_query": "apartments with dishwasher in Madison County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Madison County",
      "h2_subtitle": "Find the perfect apartment with a dishwasher at Mark Apts. in Madison County. Enjoy stress-free living with modern conveniences.",
      "page_copy": "At Mark Apts., located within Madison County, you're welcomed with well-equipped kitchens featuring dishwashers that make daily living more convenient. Our apartments provide everything you need to ensure a stress-free lifestyle, from user-friendly layouts to modern amenities.\n\nBeyond the kitchen, enjoy our refreshing pool, vibrant clubhouse, and spacious walk-in closets. Whether you choose a one- or two-bedroom apartment, each unit offers scenic balconies and a smoke-free environment. Discover how our apartments with dishwashers can make your life in Madison County more enjoyable and efficient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Madison County",
      "seo_description": "Live conveniently at Mark Apts. in Madison County with apartments featuring dishwashers. Enjoy a stress-free lifestyle with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "washer-dryer-hookup-apartments-ridgeland-the-mark",
      "search_query": "washer dryer hookup apartments Ridgeland",
      "category": "Amenity",
      "h1_title": "Washer Dryer Hookup Apartments in Ridgeland",
      "h2_subtitle": "Explore the convenience of washer dryer hookup apartments at Mark Apts. in Ridgeland. Enjoy modern living with top-notch amenities.",
      "page_copy": "Mark Apts. in Ridgeland offers the perfect blend of comfort and convenience with our washer dryer hookup apartments. No more trips to the laundromat—enjoy the luxury of doing laundry in the comfort of your own home. With thoughtfully designed spaces and modern features, you can truly experience hassle-free living.\n\nOur vibrant community features a sparkling pool and a lively clubhouse, ideal for relaxation and entertainment. Each apartment includes spacious walk-in closets and scenic balconies, ensuring you have everything you need for a comfortable lifestyle in Ridgeland. Visit us today to see how our washer dryer hookup apartments make everyday life easier and more enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Hookup Apartments in Ridgeland",
      "seo_description": "Experience convenience at Mark Apts. with washer dryer hookup apartments in Ridgeland. Enjoy modern living with exceptional amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "walk-in-closets-apartments-39157-the-mark",
      "search_query": "apartments with walk-in closets 39157",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-In Closets in 39157",
      "h2_subtitle": "Discover spacious apartments with walk-in closets at Mark Apts. in the 39157 area. Enjoy comfortable living with ample storage.",
      "page_copy": "At Mark Apts. in the 39157 area, we offer thoughtfully designed apartments featuring spacious walk-in closets that provide ample room for your belongings. No more clutter—experience the joy of organized living with plenty of storage space in each of our units.\n\nAlong with generous closet space, our community features modern amenities like a sparkling pool and a vibrant clubhouse. Choose from stylish one- or two-bedroom apartments, complete with scenic balconies and convenient on-site maintenance. Make Mark Apts. your next home and enjoy all the benefits of comfortable living in Ridgeland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Closets in 39157",
      "seo_description": "Find spacious living at Mark Apts. in Ridgeland, 39157, featuring walk-in closets. Enjoy modern amenities and comfortable living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-ridgeland-ms-the-mark",
      "search_query": "1 bedroom apartments in Ridgeland MS",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Ridgeland, MS",
      "h2_subtitle": "Explore stylish 1 bedroom apartments at Mark Apts. in Ridgeland, MS. Enjoy modern amenities and a welcoming community.",
      "page_copy": "Mark Apts. offers the ideal setting in Ridgeland, MS, for those seeking comfortable 1 bedroom apartments. Each unit is thoughtfully designed to provide ample living space, featuring modern amenities that cater to a convenient lifestyle. Whether you prefer lounging by the pool or socializing in the vibrant clubhouse, our community offers the perfect backdrop for relaxation and enjoyment.\n\nOur 1 bedroom apartments come equipped with scenic balconies, providing a peaceful retreat after a long day. Plus, with on-site maintenance and spacious interiors, you'll find everything you need right at your doorstep. Discover the ease of living in Ridgeland, MS, and make Mark Apts. your home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Ridgeland, MS",
      "seo_description": "Find stylish 1 bedroom apartments at Mark Apts. in Ridgeland, MS. Enjoy modern living with top-notch amenities and a friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "2-bedroom-floor-plans-near-lake-harbour-dr-ridgeland-the-mark",
      "search_query": "2 bedroom floor plans near Lake Harbour Dr Ridgeland",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Floor Plans Near Lake Harbour Dr",
      "h2_subtitle": "Discover spacious 2 bedroom floor plans at Mark Apts, near Lake Harbour Dr in Ridgeland. Enjoy modern amenities and a vibrant community.",
      "page_copy": "Located close to Lake Harbour Dr in Ridgeland, Mark Apts. offers spacious 2 bedroom floor plans designed for modern living. Our thoughtfully designed layouts provide the space and comfort you desire, complete with scenic balconies that offer a tranquil escape from the everyday hustle. \n\nBeyond the comfort of your home, enjoy community amenities such as a refreshing pool, a lively clubhouse, and the convenience of on-site maintenance. Whether you're entertaining guests or enjoying the serene environment, our 2 bedroom apartments near Lake Harbour Dr offer the perfect setting for a vibrant lifestyle. Join our welcoming community and experience all that Mark Apts. has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Floor Plans Near Lake Harbour Dr",
      "seo_description": "Explore spacious 2 bedroom floor plans near Lake Harbour Dr in Ridgeland, MS at Mark Apts. Enjoy modern amenities and a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "apartments-near-holmes-community-college-ridgeland-the-mark",
      "search_query": "apartments near holmes community college ridgeland",
      "category": "School",
      "h1_title": "Apartments Near Holmes Community College",
      "h2_subtitle": "Live near Holmes Community College at Mark Apts. in Ridgeland. Enjoy convenience, modern amenities, and a welcoming community.",
      "page_copy": "Conveniently located just a short drive from Holmes Community College in Ridgeland, Mark Apts. offers ideal living spaces for students and staff alike. Our apartments are designed to provide comfort and convenience, featuring modern amenities that cater to a busy lifestyle. \n\nWith spacious layouts and scenic balconies, you can unwind in style. Enjoy our community's refreshing pool and vibrant clubhouse, perfect for relaxation and socializing. Experience hassle-free living with on-site maintenance, making Mark Apts. the perfect choice for those connected to Holmes Community College. Our location provides easy access to both educational and recreational activities, ensuring a balanced and fulfilling lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holmes Community College Ridgeland",
      "seo_description": "Find convenient living at Mark Apts, near Holmes Community College in Ridgeland. Enjoy modern amenities and a welcoming environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "mark-apts-near-tougaloo-college-ridgeland-ms",
      "search_query": "mark apts near tougaloo college mississippi",
      "category": "School",
      "h1_title": "Mark Apts Near Tougaloo College, MS",
      "h2_subtitle": "Discover Mark Apts, close to Tougaloo College in Mississippi. Enjoy a comfortable lifestyle with modern amenities in Ridgeland.",
      "page_copy": "Mark Apts. in Ridgeland, Mississippi, provides a perfect living location for those associated with Tougaloo College. Just a short commute away, our community offers modern 1 and 2 bedroom apartments equipped with all the comforts of home. Enjoy the seamless blend of convenience and comfort with spacious walk-in closets, scenic balconies, and on-site maintenance.\n\nWhether you're relaxing in our refreshing pool or attending a study session in the vibrant clubhouse, Mark Apts. offers a conducive environment for both students and faculty. Experience the ease of life near Tougaloo College while enjoying the benefits of our welcoming community and top-notch amenities. Make the right choice with Mark Apts. and enrich your living experience near Tougaloo College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mark Apts Near Tougaloo College, MS",
      "seo_description": "Live near Tougaloo College at Mark Apts in Ridgeland, MS. Enjoy modern amenities and a convenient, comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "apartments-near-merit-health-river-oaks-ridgeland-ms-the-mark",
      "search_query": "apartments near Merit Health River Oaks Ridgeland MS",
      "category": "Hospital",
      "h1_title": "Apartments Near Merit Health River Oaks",
      "h2_subtitle": "Explore living options at Mark Apts, located near Merit Health River Oaks in Ridgeland, MS. Enjoy a comfortable lifestyle close to work.",
      "page_copy": "For those seeking a convenient living situation near Merit Health River Oaks in Ridgeland, MS, Mark Apts. offers the perfect solution. Our stylish one and two-bedroom apartments provide an ideal home base with easy access to the hospital. Enjoy a stress-free commute and return to a community that caters to your comfort.\n\nMark Apts. features modern amenities including a refreshing pool and vibrant clubhouse, enhancing both relaxation and social options. With scenic balconies and ample walk-in closets, our apartments ensure you have both the space and tranquility you desire. Choose Mark Apts. for a harmonious work-life balance near Merit Health River Oaks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Merit Health River Oaks Ridgeland MS",
      "seo_description": "Find convenient living at Mark Apts, near Merit Health River Oaks in Ridgeland, MS. Enjoy modern amenities and a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "apartments-close-to-childrens-medical-group-39157-the-mark",
      "search_query": "apartments close to Children's Medical Group in 39157",
      "category": "Hospital",
      "h1_title": "Apartments Close to Children's Medical Group",
      "h2_subtitle": "Discover Mark Apts in the 39157 area, conveniently close to Children's Medical Group. Enjoy modern living with quick access to healthcare services.",
      "page_copy": "Situated in the heart of Ridgeland, Mark Apts. offers an excellent location for those needing proximity to Children's Medical Group in the 39157 area. Our well-appointed one and two-bedroom apartments blend comfort with modern amenities, making it an ideal choice for healthcare professionals and families alike.\n\nRelax in our inviting community, featuring a refreshing pool and vibrant clubhouse, perfect for unwinding after a day at work. Our spacious interiors, complete with walk-in closets and scenic balconies, provide a peaceful retreat while keeping you connected to important healthcare services just around the corner. Choose Mark Apts. for convenience and quality living near Children's Medical Group.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Children's Medical Group 39157",
      "seo_description": "Live near Children's Medical Group in Ridgeland, MS 39157 at Mark Apts. Enjoy modern amenities and convenient healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "apartments-near-lefleurs-bluff-state-park-ridgeland-ms-the-mark",
      "search_query": "apartments near LeFleur's Bluff State Park Mayes Lake Ridgeland MS",
      "category": "Park",
      "h1_title": "Apartments Near LeFleur's Bluff State Park",
      "h2_subtitle": "Find your home at Mark Apts, near LeFleur's Bluff State Park in Ridgeland, MS. Enjoy outdoor adventures just steps away from your doorstep.",
      "page_copy": "Experience the best of Mississippi living at Mark Apts, conveniently located near LeFleur's Bluff State Park and Mayes Lake in Ridgeland. Our modern one and two-bedroom apartments offer the perfect retreat for nature enthusiasts and anyone who appreciates serene, scenic environments.\n\nWhether you love hiking, picnicking, or boating, living close to LeFleur's Bluff State Park ensures you're always near the action. Return home to unwind with amenities like a refreshing pool and a vibrant clubhouse. Discover the joy of outdoor living and the comfort of comprehensive apartment features at Mark Apts, perfectly situated for both adventure and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near LeFleur's Bluff State Park MS",
      "seo_description": "Live near LeFleur's Bluff State Park in Ridgeland, MS at Mark Apts. Enjoy modern amenities and outdoor adventure close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "apartments-close-to-freedom-ridge-ridgeland-ms-the-mark",
      "search_query": "apartments close to Freedom Ridge Ridgeland Mississippi",
      "category": "Park",
      "h1_title": "Apartments Close to Freedom Ridge",
      "h2_subtitle": "Enjoy easy access to Freedom Ridge in Ridgeland, Mississippi, by choosing the comfortable living options at Mark Apts.",
      "page_copy": "Located in Ridgeland, MS, Mark Apts. offers premium apartment living just moments away from the vibrant Freedom Ridge park. Our tasteful one and two-bedroom layouts provide a perfect setting for those who appreciate both convenience and comfort in their living situation.\n\nTake advantage of the nearby Freedom Ridge park's recreational opportunities and then return to enjoy our apartment community's modern amenities, including a refreshing pool and a lively clubhouse. Mark Apts. combines the tranquility of a park-side location with the convenience of living in a well-connected neighborhood, making it an ideal choice for those looking to enjoy all that Ridgeland has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Freedom Ridge Ridgeland MS",
      "seo_description": "Find comfort at Mark Apts near Freedom Ridge in Ridgeland, MS. Enjoy modern living with easy access to local parks and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "apartments-by-winners-circle-park-ridgeland-39157-the-mark",
      "search_query": "apartments by Winners Circle Park Ridgeland 39157",
      "category": "Park",
      "h1_title": "Apartments by Winners Circle Park",
      "h2_subtitle": "Live next to Winners Circle Park in Ridgeland, 39157, at Mark Apts. Enjoy luxury living alongside incredible recreational opportunities.",
      "page_copy": "If you're looking for a prime living location near Winners Circle Park in Ridgeland, 39157, Mark Apts. is an excellent choice. Experience the perfect blend of luxury and convenience with our stylish one and two-bedroom apartments, situated just minutes from the park's beautiful recreational spaces.\n\nEmbrace an active lifestyle with easy access to Winners Circle Park’s facilities, then unwind at home with our premium amenities like a sparkling pool and community clubhouse. At Mark Apts., you'll enjoy the dual benefit of a peaceful home environment with the excitement of nearby recreational pursuits, all in the heart of Ridgeland, Mississippi.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Winners Circle Park Ridgeland 39157",
      "seo_description": "Discover Mark Apts by Winners Circle Park, Ridgeland 39157. Enjoy modern amenities and outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "living-near-old-trace-park-ridgeland-ms-the-mark",
      "search_query": "living near Old Trace Park Ridgeland MS",
      "category": "Park",
      "h1_title": "Living Near Old Trace Park",
      "h2_subtitle": "Experience the charm of living near Old Trace Park in Ridgeland, MS. Mark Apts offers the perfect blend of comfort and location.",
      "page_copy": "Discover the benefits of living near Old Trace Park by choosing Mark Apts as your new home in Ridgeland, Mississippi. Our thoughtfully designed one and two-bedroom apartments provide a comfortable retreat just steps away from the serene views and recreational opportunities of Old Trace Park.\n\nEnjoy spacious living with amenities such as walk-in closets and scenic balconies, perfect for enjoying the Mississippi sunsets. With Old Trace Park's beauty close by and modern community features like a refreshing pool and clubhouse at your fingertips, Mark Apts creates an inviting living experience tailored for both relaxation and adventure seekers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Old Trace Park Ridgeland MS",
      "seo_description": "Mark Apts offers unparalleled living near Old Trace Park in Ridgeland, MS, with modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165610",
      "source": "generator",
      "page_item_url": "residences-close-to-flowood-nature-park-ridgeland-the-mark",
      "search_query": "residences close to Flowood Nature Park Ridgeland",
      "category": "Park",
      "h1_title": "Residences Close to Flowood Nature Park",
      "h2_subtitle": "Mark Apts. offers residences close to Flowood Nature Park, a serene escape in Ridgeland with luxurious amenities and natural beauty.",
      "page_copy": "Enjoy the tranquility of nature with residences close to Flowood Nature Park at Mark Apts in Ridgeland. Our one and two-bedroom apartments deliver a perfect blend of comfort and convenience, just a short drive from the park's lush landscapes and outdoor adventures.\n\nResidents relish in our modern amenities like a sparkling pool and vibrant clubhouse, which complement the peaceful ambiance provided by proximity to Flowood Nature Park. Mark Apts. invites you to experience a harmonious lifestyle set against the backdrop of Ridgeland’s stunning natural environment, offering both relaxation and recreation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and a dishwasher.",
        "public_id": "019cfb42-1833-728c-abf9-7c97b28f671d",
        "storage_key": "property/6767906449165610/019cfb42-1833-728c-abf9-7c97b28f671d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Flowood Nature Park in Ridgeland",
      "seo_description": "Discover Mark Apts, offering residences close to Flowood Nature Park in Ridgeland. Enjoy nature and luxurious living combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5184"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-T4BRPHZJB9"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151231"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-mark-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W8HQTJWT"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165610/019d1bd8-9a07-73b9-9722-a1877a655ab6.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "33359832237"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-343-1146"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af6fa03723ddf0f25abb"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjZoTm5ZSWhUTUxXQkxWazE3WEVrZlE9PSIsInZhbHVlIjoiVDUxdEE0KzBrbGpGZ1VONXhBNEh6dz09IiwibWFjIjoiZGMwN2I1OTdmM2UwYmQ4MjA2OTQ4OTJjYjU1OTE2ZDc2MDU4Y2JhZDMyNjRkNGZjODFhODBiNTE5N2EwMTNkZCJ9"
    }
  ],
  "custom_qb_id": "5184",
  "custom_ga4_id": "G-T4BRPHZJB9",
  "custom_repli_id": "10041151231",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-mark-apartments/register/",
  "custom_google_gtm_id": "GTM-W8HQTJWT",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165610/019d1bd8-9a07-73b9-9722-a1877a655ab6.pdf",
  "custom_hubspot_company_id": "33359832237",
  "custom_ppc_tracking_phone_number": "888-343-1146",
  "custom_residentboost_apartment_id": "6504af6fa03723ddf0f25abb",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjZoTm5ZSWhUTUxXQkxWazE3WEVrZlE9PSIsInZhbHVlIjoiVDUxdEE0KzBrbGpGZ1VONXhBNEh6dz09IiwibWFjIjoiZGMwN2I1OTdmM2UwYmQ4MjA2OTQ4OTJjYjU1OTE2ZDc2MDU4Y2JhZDMyNjRkNGZjODFhODBiNTE5N2EwMTNkZCJ9"
};

export const generatedAt = '2026-08-27T21:37:55.668Z';
